<template>
    <div class="uslugi">
        <h4 style="align-self: flex-start;">Пациентам</h4>
        <div class="patients">
            <div v-if="desktop" style="width:25%; padding:2rem">
                <div class="info" @click="chooseMenu(commonInfo, { title: 'Общая информация', value: 'common_info'})">Общая информация</div>
		<div class="info" @click="chooseMenu(beremInfo, { title: 'О беременности', value: 'berem_info'})">О беременности</div>
                <div class="info" @click="chooseMenu(abortInfo, { title: 'О аборте', value: 'abort_info'})">Об аборте</div>
                <div class="info" v-b-toggle.collapse-1>Услуги <span class="material-icons">keyboard_arrow_down</span></div>
                <b-collapse id="collapse-1" class="mt-2">
                    <ol class="rounded">
                        <li @click="currentService(service)" v-for="service in services" :key="service.text"><a>{{service.text}}</a></li>
                    </ol>
                </b-collapse>
                <div @click="chooseMenu(prices, { title:'Цены', value: 'prices'})" class="info">Цены</div>
            </div>
            <b-dropdown v-else variant="info" style="width:100%">
                <template #button-content>
                    {{currentMenu.title}}
                </template>
                <b-dropdown-item @click="chooseMenu(commonInfo, { title: 'Общая информация', value: 'common_info'})">Общая информация</b-dropdown-item>
                <b-dropdown-group id="dropdown-group-2" header="Услуги">
                    <b-dropdown-item-button @click="currentService(service)" v-for="service in services" :key="service.text">{{service.text}}</b-dropdown-item-button>
                </b-dropdown-group>
                <b-dropdown-item @click="chooseMenu(prices, { title:'Цены', value: 'prices'})">Цены</b-dropdown-item>
            </b-dropdown>
            <div :style="{ width: desktop ? '75%' : '100%'}">
                <h5>{{currentMenu.title}}</h5>
                <b-button v-if="isOrgAdmin" variant="info" @click="openEdit()">Редактировать</b-button>
                <div id="viewer">
                </div>
            </div>
        </div>
        <Dialog v-if="open_edit">
            <h4 slot="header">Редактирование</h4>
            <div slot="body" id="editor" style="max-height:200px;overflow:auto">
            </div>
            <div slot="footer">
                <b-button variant="info" @click="edit_content()">Сохранить</b-button>
                <b-button variant="danger" @click="closeEdit()">Отменить</b-button>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Dialog from '@app/views/custom-components/modals/edit-modal.vue';
import { organizationApi } from '@app/services';

export default {
    components: {
        Dialog
    },
    data() {
        return {
            desktop: null,
            open_edit: false,
            quill: null,
            edit_quill: null,
            mainInfo: true,
            currentMenu: { title: 'Общая информация', value: 'common_info'},
            currentSrv: null
        };
    },
    computed: {
        services() {
            return this.$store.state.clinic.organization.form.front.services;
        },
        commonInfo() {
            return this.$store.state.clinic.organization.form.front.common_info ?
            this.$store.state.clinic.organization.form.front.common_info :  [{insert: 'Не заполнено'}];
        },
	beremInfo() {
            return {
    'ops': [
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Избегание факторов риска для профилактики осложнений во время беременности:'
        },
        {
            'insert': '\nНи в коем случае нельзя ограничивать потребление жидко­сти! Для облегчения состояния и уменьшения частых позывов к мочеиспусканию нужно исключить продукты, обладающие мочегонным действием: чай, кофе, кабачки, арбуз; а также солёную, острую и жареную пищу.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Носите удобное хлопчатобумажное бельё, которое не сдавливает низ живота.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Для уменьшения тошноты и рвоты утром попробуйте съедать что-нибудь до того, как встанете с постели. Это может быть сухарик, печенье, несколько глотков воды. После перекуса полежите некоторое время. Облегчить состояние могут вода с лимоном, имбирный чай, а также ароматерапия с эфирными маслами цитрусовых.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Питание во время беременности: Для рационального питания очень важен режим приёма пищи. Принимать пищу лучше 4–5 раз в день, причём мясо, рыбу, крупы следует употреблять утром или днём, а за ужином желательно ограничиться молочно-растительной пищей. С осторожностью добавляйте в пищу поваренную соль, лучше использовать йодированную. Рекомендуемая норма — не более 5 г в день, однако помните, что соль уже содержится во многих продуктах питания, поэтому старайтесь не досаливать пищу.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Какие продукты лучше исключить из рациона питания на протяжении всей беременности? Аллергией грозят клубника, помидоры, какао, шоколад, цитрусовые и креветки, употребляемые в больших количествах. Повышенную нагрузку на пищеварение беременной оказывают мясные и рыбные бульоны, лук и чеснок. Нежелательны продукты, богатые специями и пряностями, а также содержащие много консервантов, красителей и ароматизаторов. Следует ограничивать также продукты с большим содержанием животных жиров (жирные сорта мяса, сало, колбасные изделия, сосиски).\nИсключите все продукты и лекарства, которые могут содержать вещества, опасные для плода при приёме в существенных количествах, например пищу и добавки с большими концентрациями витамина А (в частности, печень трески или минтая).\nЛучше отказаться от продуктов, которые могут быть микробиологически небезопасными и служить источником инфекций и паразитов (незрелые мягкие сыры, непастеризованное молоко, термически недообработанные рыба, мясо, курица, плохо промытые овощи, сырые или недоваренные яйца).\nОт правильного питания во время беременности и исходного ИМТ зависит прибавка массы тела.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Нормы прибавки веса при беременности в зависимости от ИМТ:\nДля женщин с ИМТ 18,5–24,9 кг/м2 —11,5–16 кг за беременность, за 1 неделю 440-580г.'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'Для пациенток с дефицитом массы тела (ИМТ менее 18,5 кг/м2) — 12,5–18 кг за беременность, за 1 неделю-350-500г.'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'При прегравидарном избытке массы тела (ИМТ 25,0–29,9 кг/м2) — 7–11,5 кг за беременность, за 1 неделю-230-330г'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'При ожирении (ИМТ 30,0 кг/м2 и более) — 5–9 кг за беременность, за 1 неделю-170-270г'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'Оценка еженедельной прибавки массы тела во время беременности, особенно во II и III триместрах, позволяет косвенно судить о течении гестации.\nПрофилактика несвоевременного и неполного опорожнения кишечника. Употребляйте больше овощей и фруктов, пейте воду. Старайтесь есть часто небольшими порциями.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Профилактика болезненности молочных желез: Подберите удобное бельё.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Профилактика заложенности носа, носовых кровотечений: Ииспользование увлажнителя воздуха. Если у вас его нет, можно положить влажное полотенце на батарею — менее эффективно, но лучше, чем ничего. Возможно применение спреев с морской солью, но нужно внимательно читать инструкцию и особенно раздел «Показания», там должна содержаться информация о безопасности средства во время беременности.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Изменения АД: Если вы впервые обнаружили у себя высокое нормальное давление, повторите измерение через 15 мин. Если давление остаётся повышенным, обратитесь к врачу. Ведите дневник измерений артериального давления, особенно при склонности к гипертензии. Показывайте дневник врачу на каждом приёме.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'отказ от работы, связанной с длительным стоянием или с излишней физической нагрузкой, работы в ночное время и работы, вызывающей усталость. Данные виды работ ассоциированы с повышенным риском ПР, гипертензии, ПЭ и ЗРП.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Беременной пациентке должны быть даны рекомендации по отказу от работы, связанной с воздействием рентгеновского излучения.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Беременные с нормальным течением беременности должны заниматься умеренной физической нагрузкой (20-30 минут в день). Физические упражнения, не сопряженные с избыточной физической нагрузкой или возможной травматизацией женщины, не увеличивают риск ПР и нарушение развития детей.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Избегать физических упражнений, которые могут привести к травме живота, падениям, стрессу (например, контактные виды спорта, такие как борьба, виды спорта с ракеткой и мячом, подводные погружения).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'При нормальном течении беременности пациентке не должны даваться рекомендации по отказу от половой жизни, так как половые контакты при нормальном течении беременности не увеличивают риск ПР и перинатальной смертности.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Беременные, совершающей длительные авиаперелеты, должны быть даны рекомендации по профилактике ТЭО, такие как ходьба по салону самолета, обильное питье, исключение алкоголя и кофеина и ношение компрессионного трикотажа на время полета. Авиаперелеты увеличивают риск ТЭО, который составляет 1/400-1/10000 случаев, вне зависимости от наличия беременности. Так как часто имеют место бессимптомные ТЭО, этот риск может быть еще выше (примерно в 10 раз).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Беременной пациентке должны быть даны рекомендации по образу жизни, направленному на снижение воздействия на организм вредных факторов окружающей среды (поллютантов). Выявлен повышенный риск невынашивания беременности, ПР, гестационной артериальной гипертензии и других осложнений беременности вследствие воздействия поллютантов, содержащихся в атмосферном воздухе, воде и продуктах питания (например тяжелых металлов – мышьяка, свинца и др., органических соединений –'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'бисфенола A и др.).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Обязательный отказ от курения!!!!!!!!!! Курение во время беременности ассоциировано с такими осложнениями как ЗРП, ПР, предлежание плаценты, преждевременная отслойка нормально расположенной плаценты (ПОНРП), гипотиреоз у матери, преждевременное излитие околоплодных вод, низкая масса тела при рождении, перинатальная смертность и эктопическая беременность. Дети, рожденные от курящих матерей, имеют повышенный риск заболеваемости бронхиальной астмой, кишечными коликами и ожирением.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Беременной пациентке должны быть даны рекомендации по отказу от приема алкоголя во время беременности, особенно в 1-м триместре. Несмотря на отсутствие высоко доказательных данных негативного влияния малых доз алкоголя на акушерские и перинатальные осложнения, накоплено достаточное количество наблюдений о негативном влиянии алкоголя на течение беременности вне зависимости от принимаемой дозы алкоголя, например алкогольный синдром плода и задержка психомоторного развития.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О ВНУТРИУТРОБНОМ РАЗВИТИИ РЕБЕНКА ПО НЕДЕЛЯМ БЕРЕМЕННОСТИ С ОПИСАНИЕМ ЕГО СПОСОБНОСТЕЙ'
        },
        {
            'insert': '\n1-4 неделя — беременность наступает обычно на 14-й день менструального цикла, после оплодотворения яйцеклетка прикрепляется к стенке матки, происходит образование нервной системы, мозга и сердца малыша. Формируется позвоночник и мышцы. На 4 недели длина эмбриона достигает 2-3 мм, уже можно определить ножки, ручки, ушки и глаза малыша.\n5-8 неделя — в этот период женщины обнаруживают, что беременны и делают подтверждающий тест. На 6 недели на УЗИ можно увидеть 5 пальцев на руке ребенка и различить его осторожные движения. Сердце его уже бьется, но с частотой превышающий в 2 раза ритм сердечных ударов мамы.\nНа 7-8 неделе оформляется лицо ребенка, начинает развиваться его костная система. Вес его достигает 4 граммов, рост около 3 см. В этот период беременности многих женщин начинает тошнить по утрам.\n9-12 недель — малыш уже может сгибать пальчики на руках, он теперь умеет выражать свои эмоции: щурится, морщит лоб и глотает. Содержание гормонов в крови беременной в этот период резко возрастает, что сказывается на настроении и самочувствии женщины. В 11 недель малыш реагирует на шум, тепло и свет. Он чувствует прикосновение и боль. В 12 недель по результатам УЗИ врач точно может определить срок родов и оценить, нет ли отклонений в развитии малыша. Трехмесячный младенец в утробе мамы очень активен, он легко отталкивается от стенки матки, сосет большой пальчик и реагирует на внешние раздражители. Весит он уже 28 грамм, а рост у него около 6 см.\n13-16 недель — у ребенка формируются половые органы, поджелудочная железа начинает вырабатывать инсулин. Его сердце уже перекачивает 24 литра крови в сутки. На голове малыша есть волосы, он умеет уже открывать рот и гримасничать. В этот период маме надо стараться контролировать свои эмоции и оставаться спокойной в любых ситуациях. Все, что она чувствует, уже передается малышу. Если ей плохо, то ребенок тоже расстраивается.\n17-20 недель — это особенно волнующий период для будущей мамы, ибо на 18 −20 неделе она начинает чувствовать, как ребенок шевелится. К этому времени длина малыша достигает 21 см, вес его 200 гр. Он уже слышит шум и немного видит. В этот период следует каждый день разговаривать с малышом и петь ему песенки. Он уже слышит голос мамы и успокаивается, когда с ней все в порядке. Живот у беременной женщины на 20 недели становится заметным.\n21-24 неделя — малыш в этом возрасте умеет причмокивать ртом и начинает внимательно изучать свое тело. Он трогает лицо, голову и ноги руками. Но выглядит он еще сморщенным и красным из-за отсутствия подкожной жировой прослойки. Вес малыша около 0,5 кг, рост 30 см. Ему уже не нравится, когда мама долго сидит в одном положении. Он усиленно шевелится, чтобы заставить ее подняться с места. С этого времени маме надо следить за своим рационом, хорошо питаться и больше гулять на свежем воздухе.\n25-28 недель — ребенок, родившийся в этот период, имеет реальные шансы выжить. У него глаза уже открыты, есть ресницы, он сжимает и разжимает ручки. Весит он к 28 недели около 1 кг и сильно радуется, когда папа поглаживает живот мамы. Ему нравится слушать музыку и спокойную беседу родителей.\n29-32 недели — теперь малыш четко различает голоса мамы и папы. Он затихает, если мама ему скажет спокойным голосом: «Сыночек (доченька), хватит на сегодня играть, давай спать». Он быстро набирает в весе и к 32 недели весит уже больше 1,5 кг при росте 40 см. У малыша кожа уже подтянутая, а под ней имеется жирок.\n32-40 недель — ребенок разворачивается головой вниз и готовится к рождению. Каждую неделю он теперь набирает 200-300 грамм веса и к рождению достигает 2,5 — 4 кг. За весь период внутриутробного развития у малыша сильно подросли ногти и волосы, в его кишечнике накопились отходы жизнедеятельности. На 40 недели у многих женщин начинаются схватки, и приходит время рожать. Если этого не происходит, то это говорит о том, что малыш «засиделся» и усиленно набирает вес. По статистике, только 10% женщин дохаживают до 42-ой недели беременности, после этого срока гинекологи уже стимулируют роды.\n\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О Партнерских родах'
        },
        {
            'attributes': {
                'header': 3
            },
            'insert': '\n'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Партнерские роды'
        },
        {
            'insert': ' — это роды с помощником, когда помимо акушерки, врача и других сотрудников роддома вместе с роженицей в родильном зале присутствует близкий ей человек. Чаще всего в роли такого «внештатного» помощника выступает отец ребенка: мужчина помогает женщине в процессе родов и морально, и физически. Таким образом, семья переживает это важнейшее событие вместе.\nДля многих западных стран практика партнерских родов уже давно стала рядовым явлением. В нашей стране она была редкостью, пока новый Федеральный закон от 21.11.2011 № 323-ФЗ «Об основах охраны здоровья граждан в Российской Федерации» не утвердил право «отцу ребенка или иному члену семьи при наличии согласия женщины и с учетом ее состояния здоровья присутствовать при рождении ребенка».\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Плюсы и минусы партнерских родов'
        },
        {
            'insert': '\nВопрос о партнерских родах очень деликатный и решается каждой парой индивидуально. Однако есть общие аргументы «за» и «против» родов с помощником, которые надо обязательно проанализировать.\n'
        },
        {
            'attributes': {
                'italic': true,
                'bold': true
            },
            'insert': 'Доводы «за»'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '1.'
        },
        {
            'insert': ' Самое главное здесь — абсолютно логичное право отца участвовать в событии, которое является едва ли не самым важным в жизни молодой семьи. Если женщина здорова и роды идут нормально, то нет причин запрещать мужу присутствовать при появлении ребенка на свет. Партнерские роды — это не только вопрос гуманизации медицины, т.е. большего уважения к пациенту, открытости и человечности (курс медицины всего мира!), но и важный воспитательный фактор для молодых родителей. Известно, что у мужчин, присутствующих на родах, отцовский инстинкт просыпается намного быстрее.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '2. '
        },
        {
            'insert': 'Роды — это естественный финал беременности, которую современный мужчина переживает вместе со своей женщиной, самый трудный этап долгого пути, который они прошли вместе. Кому же, как не ему, и сейчас быть опорой и поддержкой любимой женщине? Семейные узы будут крепче, уважение мужа к своей жене — сильнее. Небезразлично это и для ребенка. Уже в первые минуты жизни у младенца начинают образовываться психологические связи. Счастливое «фото» обоих родителей, запечатленное в подсознании новорожденного, безусловно, сыграет положительную роль в формировании новой личности.\n'
        },
        {
            'attributes': {
                'italic': true,
                'bold': true
            },
            'insert': 'Доводы «против»'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '1.'
        },
        {
            'insert': ' Если в семье напряженная атмосфера, и совместными родами женщина хочет «наказать» супруга, продемонстрировав ему на таком личном примере, кому в семье живется труднее, нужно остановить себя, т.к. это тупик, который может привести лишь к еще большему разладу в супружеской паре.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '2.'
        },
        {
            'insert': ' Мужчина должен прежде всего сам выразить желание присутствовать на родах. Если он боится врачей, падает в обморок от вида крови — партнерские роды не для него, он, как слишком впечатлительный, будет плохим помощником в процессе родов. Однако упрекать его за это не следует. Во-первых, отказ не несет никакой отрицательной характеристики его как мужа и будущего отца. Во-вторых, есть много примеров, когда молодой отец, отказавшийся присутствовать на первых родах своей жены, был прекрасным помощником при рождении второ­го ребенка.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '3. '
        },
        {
            'insert': 'Если известна склонность мужчины в трудный момент — от сильных переживаний или растерянности — обвинять в происходящем всех и вся, его нужно отговорить от партнерских родов. Такой «помощник» будет мешать врачебной бригаде, особенно если во время родов возникнут те или иные отклонения. Он может начать давать советы, настаивать на них, спорить или ссориться с медперсоналом, что совершенно никому не нужно.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '4. '
        },
        {
            'insert': 'Нельзя воспринимать партнерские роды и как некую моду, которой нужно непременно соответствовать. Десятки причин могут заставить женщину усомниться в правильности такого нововведения: например, культурологические или религиозные соображения, твердое убеждение женщины, что перед мужчиной всегда следует представать «одетой с иголочки». Какими бы ни были причины, они окончательны и обжалованию не подлежат. Если принимается решение рожать, как и было принято десятилетиями — только в окружении медперсонала, муж впервые увидит ребенка только при выписке из роддома. И это будет такой же прекрасный праздник для всей семьи.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Подготовка к партнерским родам'
        },
        {
            'insert': '\nПомимо полной открытости и доверия в семье, необходимых для партнерских родов, важно, чтобы мужчина прошел соответствующую подготовку. Кстати, папам обучение на курсах будущих родителей дается на удивление легко — обладающие системным мышлением мужчины едва ли не лучше женщин познают все премудрости этапов прохождения родов. Положительный настрой, полная осведомлен­ность о том, что происходит в конкретный период родов, и практические умения помогать женщине перенести боль и страдания во время родовых схваток — это то, что требуется от мужчины в родовом зале.\nХорошие результаты дает следующий процесс: дополнительная встреча мужа с врачом, который будет принимать у женщины роды, чтобы тот еще раз объяснил, в чем конкретно будут заключаться функ­ции «внештатного» помощника.\nУ администрации лечебного учреждения, в котором предстоят партнерские роды, необходимо узнать, какие медицинские обследования должен пройти мужчина, чтобы его допустили в родильный зал. Чаще всего это — флюорография, анализы на ВИЧ, гепатит, СПИД и сифилис. Перед тем как ехать в роддом, надо принять душ, одеть чистое нижнее белье и взять с собой новые пластиковые тапочки. Одноразовый костюм и шапочку выдают на месте. Нужно заранее спросить разрешения у администрации роддома вести фото- или видеосъемку.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Поведение в родильном зале'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '1.'
        },
        {
            'insert': ' Самое главное — это позитивный настрой молодого отца. Следует помнить, что женщине нужна прежде всего психологическая под­держка. Все болевые ощущения, которые в эту минуту кажутся ей невыносимыми, забудутся очень скоро. Нужно подбадривать жену, обнимать ее и не скупиться на ласковые слова. От неприятных ощущений можно отвлечь разговорами и шуткой.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '2. '
        },
        {
            'insert': 'Нужно внимательно слушать жену и делать то, что она просит, — поправлять подушку, вытирать ей лоб полотенцем, если врачи разрешат, помочь помыться под душем, делать ей массаж поясницы, как учили на курсах, помогать ровно дышать.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '3. '
        },
        {
            'insert': 'Нужно быть готовым к переменам настроения роженицы, никак не реагировать на них и ни в коем случае не спорить.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '4. '
        },
        {
            'insert': 'Нужно оказать женщине физическую поддержку. Если ей удобнее в какой-то момент повиснуть на руке мужа, следует дать ей эту возможность, стать для нее опорой в прямом смысле слова.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': '5. '
        },
        {
            'insert': 'Необходимо наблюдать за работой врачей и за тем, чтобы женщина четко выполняла все их команды. Хорошая практика – повторять ей команды акушерки, а также по часам засекать время между схватками и сообщать об этом медперсоналу. Сидя у изголовья женщины можно самому нарочито дышать так, как требует дышать от женщины врач.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Партнерские роды возможны только в индивидуальном родильном зале, поэтому о возможности рожать таким образок в конкретном роддоме необходимо узнавать у администраций лечебного учреждения.'
        },
        {
            'insert': '\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О понятии нормальных родов'
        },
        {
            'insert': '\nНормальные роды — это естественный процесс рождения ребенка, когда он происходит естественным путем через родовые пути матери. Нормальные роды могут происходить в домашних условиях, в родильном отделении больницы или отделении родовспоможения.\n Основные признаки нормальных родов включают правильное раскрытие шейки матки, правильное положение плода и его прохождение через родовые пути без осложнений. Нормальные роды могут быть естественными или иметь небольшое количество медицинской помощи для облегчения процесса. Важно, чтобы нормальные роды осуществлялись под контролем опытного персонала для обеспечения безопасности как матери, так и ребенка. \nНормальные роды — своевременные роды одним плодом, начавшиеся спонтанно, с низким риском акушерских осложнений к началу родов и прошедшие без осложнений, при которых ребенок родился самопроизвольно в головном предлежании, после которых родильница и новорожденный находятся в удовлетворительном состоянии. Характеристики нормальных родов: \nОдноплодная беременность.\nГоловное предлежание плода.\nСоразмерность головки плода и таза матери.\nДоношенная беременность 37 недель 1 день – 41 нед. (от первого дня последней менструации).  Координированная родовая деятельность, не требующая корригирующей терапии.\nНормальный механизм родов (передний или задний вид затылочного предлежания). \nСвоевременное излитие околоплодных вод при раскрытии шейки матки более 5 см в активную фазу первого периода родов или амниотомия по показаниям.  Отделение последа происходит самостоятельно, рождение -ï самостоятельно или наружными приемами.  Отсутствие разрывов тканей родового канала или только незначительные, поверхностные повреждения.  Отсутствие оперативных вмешательств в родах.\n  Физиологическая кровопотеря в среднем составляет 0,5% от массы тела и не должна превышать 500мл (тщательный учет!).  Средняя продолжительность физиологических родов в современных условиях колеблется от 7-8 до 16 часов у первородящих (не более 18часов), и от 5- 6 до 10 часов у повторнородящих (не более 12 часов). Рождение живого и здорового доношенного ребенка. \nЭтапы физиологических родов: первый — развитие и продолжение регулярной сократительной деятельности матки, раскрытие шейки матки второй — изгнание плода; третий — последовый. Первый период родов длится от начала первых регулярных схваток (не реже 1 в 10 минут) до полного раскрытия шейки матки и является наиболее продолжительным. У первородящих он составляет от 5-6 до 14 часов, а у повторнородящих от 4-5 до 9 часов. В первом периоде выделяют три фазы: латентная фаза первого периода родов начинается с установления регулярного ритма схваток с частотой 1-2 за 10 мин, и заканчивается сглаживанием и раскрытием маточного зева не менее чем на 4 см. Продолжительность латентной фазы у большинства рожениц составляет в среднем 4-8 часов. \nУ первородящих латентная фаза всегда длиннее, чем у повторнородящих. В этот период схватки, как правило, малоболезненные; возможно назначение спазмолитических препаратов. \nПосле раскрытия шейки матки на 4 см начинается активная фаза первого периода родов, которая характеризуется интенсивной родовой деятельностью и быстрым раскрытием маточного зева от 4 до 8 см. Продолжительность этой фазы почти одинакова у первородящих и повторнородящих женщин, и у большинства женщин составляет в среднем 3-4 часа. Частота схваток в активную фазу первого периода родов составляет 3-5 за 10 мин. Схватки нередко становятся болезненными. В этой связи применяют медикаментозное и регионарное обезболивание в сочетании со спазмолитическими препаратами. Плодный пузырь должен самостоятельно вскрываться на высоте одной из схваток при открытии шейки матки более 5 см.\nПри этом изливается около 150-250 мл светлых и прозрачных околоплодных вод. Если не произошло самопроизвольного излития околоплодных вод, то при раскрытии маточного зева 6-8 см врач должен вскрыть плодный пузырь.\n Другие показания для амниотомии – плоский плодный пузырь, появление кровяных выделений из половых путей, ослабление родовой деятельности. Одновременно с раскрытием шейки матки начинается продвижение головки плода по родовому каналу. Определение высоты стояния предлежащей части плода наружными приемами следует производить не реже 1 раза в 2 часа. Третья фаза первого периода родов – фаза замедления; начинается при 8 см и продолжается до полного раскрытия шейки матки. Эта фаза у первородящих длится до 2 часов, а у повторнородящих может вообще отсутствовать. В течение всего первого периода родов осуществляют постоянное наблюдение за состоянием матери и ее плода. Следят за состоянием роженицы (жалобы, выделения из половых путей, частота пульса, дыхания, артериальное давление — каждый час, температура тела – каждые 4 часа, частота и объем мочеиспускания – каждые 4 часа), интенсивностью и эффективностью родовой деятельности. Важным показателем течения родов является темп раскрытия шейки матки. Скорость раскрытия шейки матки в латентную фазу составляет 0,35 см/час, в активной фазе 1,5 – 2 см/час у первородящих и 2 – 2,5 см/час у повторнородящих. Нижняя граница нормальной скорости раскрытия маточного зева у первородящих 1,2 см/час, у повторнородящих 1,5 см/час. Раскрытие маточного зева в фазу замедления составляет 1 – 1,5 см/час. Регулярно выслушивают сердцебиение плода или проводится кардиомониторный контроль. Выслушивание сердцебиения плода при помощи стетоскопа производится после схватки в течение 30-60сек каждые 15 – 30 минут. Обязательно определение частоты, ритма и звучности сердечных тонов. Второй период родов — изгнание плода Период изгнания плода начинается с момента полного раскрытия шейки матки и заканчивается рождением ребенка. Длительность у первородящих 1 – 2 часа Длительность у повторнородящих от 30 минут до 1 часа Оценка состояния роженицы (общее состояние, жалобы, степень болевых ощущений, наличие головокружения, головной боли, нарушений зрения), контрольное исследование пульса и артериального давления на периферических артериях проводят в начале второго периода родов, каждые 30 минут, с наступлением потуг. До начала потуг должна быть проведена подготовка к приему ребенка (раскрытие родового комплекта, согревание пеленального стола, детского белья и др.). С началом потуг на роды вызывают неонатолога. Во II периоде головка плода большим сегментом не должна находиться в одной плоскости малого таза свыше 30 – 40 минут у первородящих и 20 – 30 минут – у повторнородящих. Определение высоты расположения головки плода осуществляется наружными приемами или влагалищным исследованием. Потуги эффективны при головке расположенной в узкой части таза или на тазовом дне Выслушивание сердцебиения плода в начале II периода родов каждые 15 минут, далее после каждой потуги. Базальная частота сердечных сокращений составляет от 110 до 170 в минуту. Ритм сердечных сокращений остается правильным. При головке, располагающейся в узкой части полости малого таза, на кардиотокограмме во время потуги могут наблюдаться ранние децелерации до 80 уд/мин, или кратковременные акцелерации до 180 уд/мин с быстрым восстановлением нормального ритма сердечных сокращений вне потуги. При удовлетворительном состоянии матери и плода во II периоде родов допустим самостоятельный выбор позы роженицы. Можно предложить ей положение на левом боку, сидя на корточках, стоя с использованием опоры. \nС момента опускания головки на тазовое дно роженица переводится на специальную кровать (кровать- трансформер). Ребенка акушерка принимает в положении роженицы полусидя с ногами, согнутыми в тазобедренных и коленных суставах и разведенными в стороны, что позволяет роженице в полной мере использовать силу рук и ног при потугах; а акушерке наблюдать за состоянием промежности, предупредить ее разрывы, бережно принять головку плода. \nРегулирование потуг в норме потуги должны появляться при расположении головки плода не выше узкой части полости малого таза, оптимально – в выходе (на тазовом дне). Если при головке плода расположенной в узкой части полости или выходе таза у женщины появляются эффективные потуги (поступательное движение головки плода при нормальном состоянии женщины и отсутствии признаков страдании плода) нет необходимости в регулировании потуг. \nПри отсутствии эффективной потужной деятельности применяют регулирование потуг, обращая внимание женщины на обеспечение правильного дыхания, координированность схватки и потуги, правильное распределение усилий направленных на продвижение головки плода: o В начале потуги роженице следует сделать максимально глубокий вдох, а затем задержать дыхание. Весь объем воздуха должен давить на диафрагму, а через нее на дно матки, как бы выталкивая плод наружу. o Когда возникает чувство нехватки воздуха, роженице необходимо плавно выдохнуть воздух и сразу же сделать максимально глубокий вдох. o За одну потугу цикл «вдох-выдох» повторить три раза. Между потугами переходят на медленное плавное дыхание. Третий период родов — последовый Третий период (последовый) определяется с момента рождения ребенка до отделения плаценты и выделения последа. В последовом периоде в течение 2-3 схваток происходит отделение плаценты и оболочек от стенок матки и изгнания последа из половых путей. У всех рожениц в последовом периоде для профилактики кровотечения внутривенно вводят препараты, способствующие сокращению матки. \nПосле родов проводят тщательное обследование ребенка и матери с целью выявления возможных родовых травм. При нормальном течении последового периода кровопотеря составляет не более 0,5 % от массы тела (в среднем 250-350 мл). Эта кровопотеря относится к физиологической, так как она не оказывает отрицательного влияния на организм женщины. После изгнания последа матка приходит в состояние длительного сокращения. При сокращении матки сдавливаются ее кровеносные сосуды, и кровотечение прекращается. \nНоворожденным проводят скрининговую оценку на фенилкетонурию, гипотиреоидизм, кистозный фиброз, галактоземию. После родов сведения об особенностях родов, состоянии новорожденного, рекомендации родильного дома передаются врачу женской консультации. При необходимости мать и ее новорожденного консультируют узкие специалисты. Документация о новорожденном поступает педиатру, который в дальнейшем наблюдает за ребенком. Следует отметить, что в ряде случаев необходима предварительная госпитализация в родильный дом для подготовки к родоразрешению. В стационаре проводят углубленное клиническое, лабораторное и инструментальное обследования для выбора сроков и метода родоразрешения. \nДля каждой беременной (роженицы) составляется индивидуальный план ведения родов. Пациентку знакомят с предполагаемым планом ведения родов. Получают ее согласие на предполагаемые манипуляции и операции в родах (стимуляция, амниотомия, кесарево сечение). \nКесарево сечение выполняют не по желанию женщины, так как это небезопасная операция, а только по медицинским показаниям (абсолютные или относительные). Роды в нашей стране ведут не дома, а только в акушерском стационаре под непосредственным врачебным наблюдением и контролем, так как любые роды таят в себе возможность различных осложнений для матери, плода и новорожденного. Роды ведет врач, а акушерка под наблюдением врача оказывает ручное пособие при рождении плода, проводит необходимую обработку новорожденного. Родовые пути осматривает и восстанавливает при их повреждении врач.\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Об обезболивании родов'
        },
        {
            'insert': '\n\nОтличается ли обезболивание при естественных родах (ЕР) и при операции кесарево сечение (КС)?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Обезболивание при естественных родах и кесаревом сечении называется по-разному. Есть два термина: аналгезия и анестезия.\nАналгезия — это частичное обезболивание при сохранении других ощущений. При естественных родах для того, чтобы нивелировать болевой синдром при схватках, уменьшить или вообще его убрать, применяется эпидуральная анальгезия, т. е. устранение боли, обезболивание. При этом женщина полностью участвует в родах. Метод обезболивания контролируемый, подачу анестетика можно уменьшать или увеличивать через специальный катетер.\nАнестезия — это подавление всех видов чувствительности. Если речь идет об оперативном родоразрешении — выполняется эпидуральная или спинальная анестезия. Женщина теряет чувствительность «ниже пояса» абсолютно на все то время, пока проводится операция.\nЧто чувствует (или не чувствует) женщина в обоих случаях?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'При анестезии боль совсем не чувствуется, потому что происходит потеря всех видов чувствительности. При аналгезии отсутствует болевой синдром, а двигательная активность и тактильная чувствительность сохраняются.\nЭпидуральной может быть и анестезия и аналгезия?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Да, но применяются они в разных случаях. Например, мы принимаем естественные роды, обезболивая их с помощью эпидуральной анальгезии. Но если в процессе возникнут разного рода проблемы, например, дистресс плода, т. е. состояние, которое возникает при недостаточном поступлении кислорода к младенцу, или изменится окраска околоплодных вод, или по другим причинам, то акушерская бригада примет решение о проведении операции — тогда мы проведем эпидуральную анестезию: пациентку переведут в операционную, подключат к соответствующим следящим за ее состоянием аппаратам, и в катетер, который мы поставили ранее и вводили туда препарат для аналгезии, будем вводить тот же препарат, но в другой, более высокой концентрации. Например, для анальгезии мы введем 2-хпроцентный раствор анестетика, а для анестезии во время операции кесарево сечение мы вводим 75-процентный.\nЭпидуральная и спинальная анестезия — это разные вещи? Когда применяется каждая?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Да, они отличаются, но принцип обезболивания один: пунктируется эпидуральное пространство, через иглу вводится катетер, через который вводится анестетик. При спинальной анестезии пунктируется спинальное, или интратекальное пространство, и с помощью иглы вводится местный анестетик, но в другой концентрации. В настоящее время применяется и эпидуральная, и спинальная анестезия. При кесаревом сечении (плановом и экстренном), как правило, применяется спинальная анестезия, потому что она быстрее и эффективнее.\nОбезболивание в родах проводят всем по желанию или только показаниям?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Сейчас роды обезболивают не только по показаниям, но и по желанию женщины, и это хорошо! Нет необходимости терпеть боль, если ее можно уменьшить. Нас часто спрашивают — платная ли это процедура? Мы проводит обезболивание родов бесплатно, этот вид медицинской помощи предоставляется по полису ОМС и обязательно — на основании письменного согласия пациентки.\nМогут ли отказать в проведении эпидуральной анестезии/аналгезии?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Могут, если есть противопоказания. Есть абсолютные противопоказания, например, непереносимость местных анестетиков, нарушения в системе гемостаза, то есть в системе свертывания крови, при продолжающихся кровотечениях. Кроме того, при всех видах шока — при массивной кровопотере (геморрагический шок) или массивной потере жидкости (гиповолемический шок).\nЕсли нет противопоказаний, можно ли попросить сделать эпидуральную аналгезию в любой момент родов? Или бывает так, что уже слишком поздно?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Если нет никаких противопоказаний, то в любой момент, кроме уже полного раскрытия шейки матки. В этом случае это уже слишком поздно, и анестезию мы делать не будем, чтобы не замедлить процесс родоразрешения.\nНасколько безопасно обезболивание (анестезия и аналгезия) для женщины и для ребенка?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Безопасно. Сегодня нет такого наркоза, который можно «не перенести». К тому же, современные препараты безвредны для матери и ребенка.\nКогда применяют общую анестезию?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Общую анестезию применяют тогда, когда противопоказана регионарная (локальная) анестезия, т. е. спинальная или эпидуральная. Также принимается во внимание желание пациентки. Выбор метода обезболивания всегда происходит в беседе с врачом анестезиологом-реаниматологом с учетом всех ЗА и ПРОТИВ. И да, на любой вид вмешательства, в том числе и обезболивание, дается письменное согласие пациентки после того, как ей разъяснены все особенности вмешательства, преимущества и риски.\nБезопасен ли общий наркоз для ребенка?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Да, безопасен и это подтверждено многочисленными исследованиями: ни здоровье, ни умственные способности детей впоследствии не страдают.\nМожет ли анестезия не подействовать? И что тогда делать?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Да, может, такое бывает и это не является внештатной ситуацией. В этом случае мы переходим на другой вид анестезии: например, если эпидуральная неэффективна, то мы можем перейти на спинальную анестезию, и она, как правило, очень эффективная. Если и спинальная анестезия не подействовала, что крайне маловероятно, то проводится операция под общим наркозом.\nКак определяют, что обезболивание начало действовать при ЕР и при КС?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'При естественных родах у пациентки происходит уменьшение болевого синдрома при схватках. Сама пациентка это почувствует и сможет отдохнуть во время схваток и даже поспать. При КС есть определенные показатели, по которым врач-анестезиолог ориентируется об эффективности действия анестезии. Это специальные пробы. Как правило, женщина узнает о начале операции в приятной беседе с анестезиологом уже после того, как акушеры-гинекологи начали свою работу)).\nКогда со мной поговорит анестезиолог по поводу обезболивания, если я приехала со схватками? А если планируется КС?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Вы обсудите этот вопрос с вашим врачом, который будет вести роды. Все зависит от степени раскрытия шейки: если раскрытие меньше 3 см, то аналгезию проводить нецелесообразно, потому что можно тем самым ослабить родовую деятельность. Когда открытие 4-5 см, то возможно применение аналгезии. Тогда в родовое отделение приходит врач-анестезиолог, беседует с пациенткой, собирает анамнез, измеряет артериальное давление, пульс. Если нет противопоказаний, то ставится внутривенный катетер для введения физиологического раствора, затем вводится анестетик.\nЕсли планируется кесарево сечение, то врач беседует с пациенткой накануне операции, подробно обсуждая показания и противопоказания к тому или иному виду обезболивания.\nСколько длится действие препарата при ЕР?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Ровно столько, сколько это необходимо, поскольку это регулируемый процесс: в катетер вводится небольшая доза препарата и затем подключается инфузомат, по которому дозированно поступает определённое количество анестетика с определённой скоростью Доза рассчитывается в зависимости от роста и веса пациентки. Весь процесс строго регулируется. Полного отключения аналгезии в процессе родов не происходит: когда наступает полное раскрытие, как правило, уменьшается доза вводимого препарата, чтобы потуги были не такими болезненными.\nЕсли есть разрывы родовых путей, под какой анестезией их зашивают?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'Если проводится эпидуральная аналгезия, то увеличивается доза обезволивающего препарата, и после того, как врач убедился, что она эффективно обезболила, акушер-гинеколог накладывает швы. Если эпидуральная аналгезия не применялась, то внутривенно вводятся обезболивающие препараты, и пока они действуют, проводятся необходимые манипуляции.\nКто до родов может помочь поработать со страхом и ожиданием боли в родах?'
        },
        {
            'attributes': {
                'header': 5
            },
            'insert': '\n'
        },
        {
            'insert': 'В наших женских консультациях есть перинатальный психолог, который может помочь проработать эти страхи. Если женщина нуждается в помощи психолога, нужна сказать об этом врачу акушеру-гинекологу, который ведет беременность. Обязательно воспользуйтесь такой возможностью — от вашего настроя и умения расслабляться и концентрироваться в нужный момент многое зависит!\nКроме того, на специальных занятиях для будущих мам наши коллеги учат немедикаментозным способам облегчения боли в родах. Вы можете узнать о такой возможности в отделе платных медицинских услуг. Заодно и будущего папу научат выполнять вместе с женщиной расслабляющие упражнения или делать специальный массаж, что пригодится в партнерских родах.\n\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О клинических симптомах, требующих незамедлительного обращения к врачу-акушеру-гинекологу'
        },
        {
            'insert': '\n\nНа что обращать внимание в третьем триместре беременности и о чём обязательно нужно сообщить врачу:\nобильные выделения из влагалища с неприятным запахом (если это молочница или инфекция, то хорошо бы с ними разобраться до родов),'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'признаки дискомфорта в области ануса, боль или появление там уплотнения, геморроя,'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'кровянистые выделения – это может быть плаценрный полип или «эрозия» шейки матки, а может быть признак преждевременной отслойки плаценты и раскрытия шейки матки. В общем это единственный повод вызвать скорую,'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'длительное отсутствие шевелений или усиление активности ребенка,'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'сильные боли в нижней трети живота – один из симптомов повышенного тонуса матки,'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'сильные отеки, резкий набор веса и высокое артериальное давление, то есть выше вашего обычного на 15-20 мм.рт.столба (головная боль, появление «мушек» перед глазами) могут быть симптомами неприятного состояния -преэклампсии.),'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'тянущие боли в области поясницы,'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'запоры (отсутствие стула в течение 24 часов),'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'появления симптомов пищевого отравления,'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'нарушение сна любого рода (трудно засыпать, часто просыпаетесь),'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'судороги или дискомфорт в икроножных мышцах.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': '\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О показаниях к кесареву сечению'
        },
        {
            'insert': '\n\n Если у Вас были выявлены показания для оперативного родоразрешения путем операции кесарева сечения. Кесарево сечение является распространенной операцией и выполняется в 25-30% всех родоразрешений. Обычно (при отсутствии особых показаний) кесарево сечение выполняется в 39-40 недель беременности.\n Для родоразрешения Вас заблаговременно госпитализируют в акушерский стационар. В случае начала родовой деятельности или разрыва плодных оболочек до предполагаемой даты родоразрешения, Вам необходимо срочно вызвать бригаду скорой помощи для госпитализации в акушерский стационар.\n В стационаре Вам будет выполнен необходимый перечень лабораторных и инструментальных исследований в зависимости от акушерской ситуации. При плановой госпитализации Вы будете должны отказаться от приема пищи за 8 часов, и прозрачных жидкостей – за 2 часа до планируемого родоразрешения. К прозрачным жидкостям относятся вода, фруктовый сок без мякоти, газированные напитки, чай и кофе.\n Перед операцией Вас проконсультируют врач-акушер-гинеколог и врач-анестезиолог-реаниматолог. Вы будете обязаны сообщить врачам обо всех известных Вам проблемах, связанных с Вашим здоровьем, наследственностью, аллергических реакциях, индивидуальной непереносимостью лекарственных препаратов и продуктов питания, а также о курении табака, злоупотреблении алкоголем или наркотическими препаратами в настоящее время и в прошлом. Врач-анестезиолог-реаниматолог выберет наиболее подходящий для Вас вид обезболивания во время операции. Перед операцией Вам будет необходимо надеть на ноги компрессионный трикотаж для профилактики тромбоэмболических осложнений, который Вы будете носить на протяжении всего послеоперационного периода. Вы будете должны удалить волосы с области предполагаемого разреза (промежность, лобок, нижняя часть живота). Также перед операцией Вам проведут антибиотикопрофилактику для снижения риска гнойно-воспалительных послеоперационных осложнений.\n В операционной Вам установят внутривенный катетер и мочевой катетер на время и первые часы после операции.\n Вы должны быть осведомлены, что во время операции могут возникнуть различные осложнения, которые могут потребовать дополнительных вмешательств и переливания препаратов, влияющих на кроветворение и кровь.\n В послеоперационном периоде Вы будете переведены в палату интенсивной терапии на необходимое время в зависимости от Вашего состояния. В послеоперационном периоде Вам продолжат обезболивание, будет предложена ранняя активизация для снижения риска послеоперационных осложнений: раннее присаживание в кровати и вставание, обычно, в 1-е сутки после родов. Прием прозрачных жидкостей возможен сразу после родоразрешения, прием пищи – через несколько часов после родов.\n Время прикладывание ребенка к груди зависит от Вашего состояния и состояния Вашего ребенка, но при отсутствии показаний практикуется раннее прикладывание: во время операции или сразу после нее.\n Удаление шовного материала проводится в стационаре или после выписки в случае необходимости, так как в ряде случаев практикуется применение рассасывающегося шовного материала.\n После выписки из стационара Вы должны будете соблюдать лечебно-охранительный режим на протяжении первых месяцев: ограничение подъема тяжестей (>5 кг), воздержание от половой жизни, а при ее возобновлении – использование методов контрацепции по рекомендации Вашего лечащего врача-акушера-гинеколога, ограничение физической нагрузки. Вы должны будете посетить Вашего лечащего врача-акушера-гинеколога через 1-1,5 месяца после родоразрешения. Планирование следующей беременности, учитывая наличие у Вас рубца на матке, рекомендовано не ранее чем через 1 год после родоразрешения после контрольного УЗИ с оценкой состояния рубца.\n Вы должны знать, что кесарево сечение является достаточно безопасной операцией, однако возможны осложнения во время ее проведения и в послеоперационном периоде:\nОчень часто — повторное кесарево сечение при последующих родоразрешениях (1 случай на каждые 4 операции).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Часто — боль в ране и дискомфорт в животе в первые несколько месяцев после операции (9 случаев на каждые 100 операций).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Часто — повторная госпитализация, послеродовая инфекция (5-6 случаев на 100 операций).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Часто – травмы плода, например, рассечение кожи скальпелем (2 случая на 100 операций).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Не часто — повторная операция в послеоперационном периоде, госпитализация в отделение интенсивной терапии (5-9 случаев на 1000 операций).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Не часто — разрыв матки в последующей беременности/родах, предлежание и врастания плаценты, кровотечение (1-8 случаев на 1000 операций).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Редко — тромботические осложнения, повреждения мочевого пузыря, повреждение мочеточника во время операции (1-5 случаев на 1000 операций).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Очень редко — смерть (1 женщина на 12 000 операций).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Также Вы должны быть осведомлены, что наличие рубца на матке может в дальнейшем снизить Вашу фертильность (способность к зачатию и деторождению). Также Вы должны знать, что после оперативного родоразрешения чаще, чем после родов через естественные родовые пути, отмечается снижение лактации.\n\nОпределение показаний к родоразрешению путем КС\n В плановом порядке родоразрешение путем КС рекомендовано при:\nпри врастании плаценты.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при неполном предлежании плаценты на расстоянии 2 см и менее от внутреннего зева родоразрешение чаще проводится путем КС, однако возможно родоразрешение через естественные родовые пути в зависимости от паритета, готовности родовых путей (наличия или отсутствия кровотечения, фазы родов.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при предлежании сосудов плаценты.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при следующих предшествующих операциях на матке: два и более КС; миомэктомия.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при наличии одного рубца на матке и категорическом отказе пациентки от родоразрешения через естественные родовые пути возможно родоразрешение путем КС.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': '\n Родоразрешение путем КС рекомендовано при гистеротомии в анамнезе (перфорация матки, иссечение трубного угла, иссечение рудиментарного рога, корпоральное КС в анамнезе, Т-образный или J-образный разрез) или при наличии препятствия со стороны родовых путей для рождения ребенка (анатомически узкий таз II и более степени сужения; деформация костей таза; миома матки больших размеров, особенно в области нижнего сегмента, препятствующая деторождению через естественные родовые пути; рубцовые деформации шейки матки и влагалища после предшествующих операций, в том числе после разрыва промежности III-IV степени; рак шейки матки, кроме преинвазивных и микроинвазивных форм рака шейки матки).\nпри предполагаемых крупных размерах плода (≥ 4500г).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при тазовом предлежании плода: при сроке беременности менее 32 недель, сочетании с другими показаниями к КС, рубцом на матке после КС, ножном предлежании плода, предполагаемой массе плода <2500 г или >3600г.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Рождение плода <2500 г или > 3600 г в тазовом предлежании не является нарушением клинических рекомендаций. Оперативное родоразрешение женщин с тазовым предлежанием носит рекомендательный характер и зависит от паритета женщины и акушерской ситуации.\nпри устойчивом поперечном положении плода.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при дистоции плечиков плода в анамнезе с неблагоприятным исходом (мертворождение, тяжелая гипоксия, энцефалопатия, травма ребенка и матери (лонного сочленения).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': '\n Для профилактики неонатального герпеса планировать родоразрешение путем кесарева сечения всем беременным, у которых первичный эпизод генитального герпеса возник после 34-й недели беременности или были выявлены клинические проявления генитального герпеса накануне родов, т.к. в этом случае существует значительный риск вирусовыделения во время родов.\n Родоразрешение путем КС рекомендовано при ВИЧ инфекции при вирусной нагрузке перед родами >1000 копий/мл, неизвестной вирусной нагрузке перед родами или неприменении противовирусной терапии во время беременности и/или непроведении антиретровирусной профилактики в родах.\nпри некоторых аномалиях развития плода (гастрошизис, омфалоцеле, крестцово-копчиковая тератома больших размеров).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при соматических заболеваниях, требующих исключения потуг (декомпенсация сердечно-сосудистых заболеваний, осложненная миопия, трансплантированная почка).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': '\nВ неотложном порядке  \n Рекомендовано при преэклампсии тяжелой степени, HELLP синдроме при беременности и в родах (при отсутствии условий для быстрого родоразрешения через естественные родовые пути).\nпри некорригируемых нарушениях сократительной деятельности матки (слабость родовой деятельности, дискоординация родовой деятельности, дистоция шейки матки), не сопровождающихся дистрессом плода.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при отсутствии эффекта от родовозбуждения окситоцином.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при хориоамнионите и неготовности естественных родовых путей к родам.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при дистресс-синдроме плода, сопровождающегося сомнительным типом КТГ, прогрессирующим, несмотря на проведенную терапию (может быть использован увлажненный #кислород и/или быстрое введение растворов, влияющих на водно-электролитный баланс, и/или смена положения тела и/или острый токолиз (гексопреналин**) или нарушением кровотока в артерии пуповины по данным допплерографии.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при любом варианте предлежания плаценты с кровотечением.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при прогрессирующей преждевременной отслойке нормально расположенной плаценты.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при угрожающем, начавшемся или свершившемся разрыве матки.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при дистресс-синдроме плода, сопровождающемся признаками прогрессирующего метаболического ацидоза по данным КТГ или уровня лактата.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при клинически узком тазе.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при выпадении петель пуповины или ручки плода при головном предлежании.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при приступе эклампсии в родах.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'при агонии или внезапной смерти женщины при наличии живого плода (при наличии возможности).'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': ' Плановое родоразрешение путем КС рекомендовано проводить в 39-40 недель беременности.\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О правильном питании и поведении во время беременности'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Первые 1,000 дней жизни'
        },
        {
            'insert': ' – это трехлетний период в жизни плода и ребенка, включающий девять месяцев беременности и два первых года жизни ребенка. Здоровое питание ребенка в течение 1,000 первых дней жизни является крайне важным, ввиду его влияния на рост и развитие ребенка, правильное развитие его мозга, иммунной системы и функциональных способностей его организма. Также известно, что питание в раннем возрасте влияет на употребление пищи, пищевые приоритеты и привычки, и на здоровье человека в дальнейшие периоды жизни – в период взросления и во взрослом возрасте. Здоровое питание является основой здорового и сбалансированного существования, предотвращения заболеваний и улучшения качества жизни на всем ее протяжении.  '
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'В период беременности питание является особенно важным.'
        },
        {
            'insert': ' Тело готовится к развитию плода и к процессу кормления. Развиваются ткани матки и плаценты, и увеличивается кровоснабжение. Нормальное прибавление веса способствует здоровью женщины и ребенка и снижает риск осложнений. \nНовейшие исследования доказывают, что питание женщины во время беременности, темп прибавления ее веса и пищевые привычки могут повлиять на когнитивное развитие эмбриона, склонность к ожирению в течение жизни, сердечно-сосудистые заболевания и т.д.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Беременная женщина должна уведомить медицинский персонал о ее состоянии здоровья и о пищевых привычках, таких, как вегетарианстве или веганизме, пищевых аллергиях, проблемах пищеварения или особой диете. '
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Необходимо подчеркнуть, что приведенные рекомендации о питании во время беременности предназначены лоя здоровых беременных женщин. Женщины с особыми пищевыми потребностями, такие, как больные диабетом, должны проконсультироваться с лечащим врачом и диетологом. Как правило, каждой беременной женщине полезно получить консультацию диетолога-специалиста по вопросам питания.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Общие правила питания'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'Министерство здравоохранения рекомендует, во время беременности и в любое другое время, употреблять продукты питания согласно принципам средиземноморской диеты. Средиземноморская диета известна своими здоровыми качествами и преимуществами в ведении здорового образа жизни и предотвращении болезней. \n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О важности прегравидарной подготовки'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'ГОТОВИТЬСЯ К БЕРЕМЕННОСТИ НЕОБХОДИМО НАЧИНАТЬ НЕ МЕНЕЕ, ЧЕМ ЗА 3 МЕСЯЦА ДО ЗАЧАТИЯ.'
        },
        {
            'insert': '\nПрегравидарная подготовка необходима всем парам, планирующим беременность, но особое значение она приобретает при отягощенном репродуктивном анамнезе.\nПП признана эффективным методом снижения риска перинатальных осложнений.\nОбследование при подготовке к беременности направлено на выявление возможных заболеваний/состояний, которые могут негативно повлиять на течение гестации. Как правило, в ходе ПП назначают такие исследования, как:\n— клинический анализ крови;\n— определение группы крови и резус-фактора;\n— определение уровня глюкозы в плазме венозной крови или в капиллярной кро- ви натощак;\n— определение антител к бледной трепонеме, антигенов и антител к ВИЧ-1 и -2, выявление HBsAg, антител к вирусу гепатита C и краснухи;\n— определение концентрации тиреотропного гормона;\n— общий анализ мочи;\n— микроскопическое исследование вагинального отделяемого с окраской по Граму, полимеразная цепная реакция для диагностики инфекций, передаваемых половым путём (ИППП), тест на вирус папилломы человека (ВПЧ) в возрасте 30 лет и старше, цитологическое исследование мазков с области экзоцервикса и из цервикального канала;\n— ультразвуковое исследование органов малого таза и молочных желёз;\n— консультация терапевта и стоматолога, другие специалисты – по показаниям!\nВ последние годы новым обязательным элементом ПП стала иммунизация против SARS-CoV-2.\nВагинозы и вагиниты, по всей вероятности, не препятствуют зачатию, хотя следует признать. Тем не менее установлено, что беременность, наступившая на фоне патологических выделений из половых путей, чаще протекает с осложнениями.\nПрисутствие ВПЧ в организме женщины может быть сопряжено с бесплодием, но в целом эти вирусы более опасны для плода, чем для фертильности. Ряд авторов полагают, что ВПЧ повышает частоту невынашивания беременности и преждевременных родов. Вирус может негативно влиять на процессы имплантации и плацентации.\nБлагоприятный исход беременности ассоциирован с низким разнообразием видового состава «репродуктивного микробиома» и доминированием представителей рода Lactobacillus. Таким образом, устранение дисбиотических нарушений – важный аспект ПП.\nВажный элемент ПП – выявление и лечение хронического эндометрита и иных ВЗОМТ на этапе планирования гестации. Наличие ВЗОМТ в анамнезе – самостоятельный фактор риска бесплодия и внематочной беременности. Если зачатие произошло, перенесённые ранее ВЗОМТ повышают риск самопроизвольного аборта, внутриутробной инфекции и хориоамнионита, плацентарной недостаточности, преждевременных родов, инфекционно-воспалительных заболеваний и осложнений у матери и новорождённого.\nДотация фолатов – один из элементов ПП, поскольку их дефицит может быть ассоциирован с многочисленными врождёнными пороками развития и осложнениями гестации. Рекомендованная доза фолиевой кислоты для взрослых женщин без отягощённого анамнеза составляет 400 мкг/сут.\nУчитывая, что вся территория РФ отнесена к зоне йододефицита, оправдана дополнительная дотация йода. В регионах, эндемичных по дефициту этого микроэлемента, в течение 3 мес до зачатия рекомендовано назначать препараты йода (женщинам –в дозе 200 мкг/сут, мужчинам – 100 мкг/сут).\nУсловно здоровым женщинам, которым не показано рутинное определение уровня 25(ОН)D в сыворотке крови, рекомендован приём витамина D в профилактической дозе 800–2000 МЕ/сут.\nЖенщине, планирующей беременность, рекомендовано включать в рацион жирную рыбу (1 раз в неделю) либо принимать препараты с полиненасыщенными жирными кислотами (ПНЖК).\nПодготовка к будущему родительству именно пары – сложный, но крайне важный процесс.\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'ОБРАЗ ЖИЗНИ В ПЕРИОД ПЛАНИРОВАНИЯ БЕРЕМЕННОСТИ:'
        },
        {
            'insert': '\n1. Отказ от вредных привычек (будущим родителям рекомендовано отказаться от употребления алкоголя, курения; недопустимо употребление наркотических веществ)\n2. Рациональное питание (отказаться от «фаст-фуда», сухомятки. Желательно исключить из рациона полуфабрикаты. Кушать нужно регулярно 4-5 раз в день небольшими порциями, не переедать. В ежедневный рацион планирующей беременность женщины должно входить побольше свежих фруктов и овощей, зелени, молочных продуктов, особенно творога и кефира, зерновых. От консервов лучше отказаться вообще. Желательно ограничить количество легко усваиваемых углеводов и животных жиров, а также кофе).\n3. Перед беременностью желательно НОРМАЛИЗОВАТЬ СВОЙ ВЕС, поскольку и избыточный вес, и чрезмерная худоба отрицательно сказываются на способности женщины зачать и выносить малыша.\n4. Физические нагрузки для подготовки к беременности (дозированные аэробные (обогащающие организм кислородом) нагрузки полезны для здоровья, они повышают стрессоустойчивость организма, улучшают кровообращение, дыхание, насыщенность кислородом, что благоприятно для зачатия ребенка.\n5. К таким нагрузкам относятся ходьба пешком (в том числе по беговой дорожке), плавание, велосипед, лыжи, коньки. Тренировка мышц брюшного пресса благоприятно скажутся на поддержании формы во время беременности и восстановление после родов, а также поможет благоприятному течению родов.\n6. Мужчинам, планирующим зачатие, необходимо избегать длительного посещения бань, саун, не стоит длительно принимать ванну с горячей водой, носить тесное белье, по возможности избегать перегрева, работы в горячем цеху.\n7. Сон и отдых (Будущим родителям важен непрерывный ночной сон в течение 8 часов в хорошо проветриваемом помещении. Ложиться спать желательно не позже 22 часов)\n8. Стрессы перед беременностью (избегать стрессовых ситуаций, учиться относиться спокойнее ко всему происходящему. Можно овладеть методиками релаксации, самовнушения, посетить психологические тренинги).\n9. Условия труда (избегать работы, связанной с длительным стоянием или с излишней физической нагрузкой, работы в ночное время и работы, вызывающей усталость)\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О лактации'
        },
        {
            'insert': '\nЛактация — процесс образования молока в молочных железах с возможностью регулярного его выведения. Начинается он под действием определенных гормонов после рождения ребёнка.\nДлительность процесса нормальной лактации у женщины находится во временном диапазоне от 5 до 24 месяцев. Количество молока, выделяемого за сутки, может колебаться, в среднем, от 0,6 до 1,3 литров. Пик его выработки наблюдается на первой и второй неделе после родов, затем идет период стабильного выделения, в соответствии с потребностью в нем конкретного ребёнка. Если женщина, в силу каких-либо причин, не прикладывает малыша к груди после родов, то лактация может прекратиться самостоятельно в течение нескольких недель.\nДоказано многочисленными научными исследованиями, что материнское молоко самым положительным способом сказывается на развитии ребенка.\nОсновные преимущества естественного вскармливания:\nВыступает полноценным источником питания. Грудное молоко является кладезем белков, жиров, витаминов и других, необходимых растущему организму, полезных макро- и микроэлементов. Содержание полезных в нем веществ может колебаться в зависимости от питания, времени года и общего самочувствия матери. Поэтому крайне важно соблюдать сбалансированное питание, которое будет удовлетворять потребности обоих организмов.\nСлужит дополнительной естественной защитой от заболеваний. Следует отметить, что все вирусы и бактерии, поражающие материнский организм, ведут к выработке иммуноглобулинов, в полной мере присутствующих в молоке. Таким образом ребёнок получает сильную иммунную защиту. Более того, грудное вскармливание способствует развитию собственной системы иммунитета, защищающей организм от различных инфекций.\nЯвляется профилактикой аллергических заболеваний. Научно доказано, что продолжительное (более года) грудное вскармливание, в сочетании со сбалансированным питанием матери, является действенной профилактикой пищевой аллергии у детей.\nСпособствует правильному формированию прикуса и развитию речевого аппарата. Правильное развитие мышц мягкого неба, которые задействованы в процессе сосания молока, способствуют более легкому воспроизведению звуков, что облегчает становление речи у ребёнка.\nСпособствует нормальному физическому развитию ребёнка. Грудное вскармливание помогает обеспечить правильное соотношение жира и мышц в детском организме. Также оно отвечает за соответствие нормам длины и массы тела ребёнка. Дети на полноценном естественном вскармливании обычно не выходят за допустимые границы показателей, определенных для их возраста.\nОбеспечивает эмоциональный комфорт ребёнку. Тесная психологическая связь между матерью и ребёнком, сформированная во время грудного кормления, сохраняется на протяжении всей жизни. Отмечено, что такие дети обычно более спокойны, а впоследствии лучше адаптируются в коллективе и во взрослой жизни.\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О полезном влиянии беременности на организм женщин'
        },
        {
            'insert': '\nПосле успешного зачатия происходит слияние биологических систем матери и её будущего ребёнка.\nИ в результате включаются пусковые механизмы физиологического процесса, названного «омолаживающая сыворотка»:\n· замедление старения организма;\n· сверхбыстрая регенерация тканей и так далее\n'
        },
        {
            'attributes': {
                'italic': true,
                'bold': true
            },
            'insert': 'Взаимосвязь поздней беременности и омоложения женского организма.'
        },
        {
            'insert': '\nНесмотря на определённые риски, которые несёт в себе поздняя беременность, специалисты отмечают оказываемое ею положительное влияние на организм матери. В ходе вынашивания младенца в кровь женщины выбрасывается повышенное количество гормонов. Они способствуют мобилизации защитных сил организма. Женщины, имеющие хотя бы одного ребёнка, живут на несколько лет дольше своих нерожавших сверстниц.\nКроме того, в их организмах происходят следующие изменения:\n· улучшение памяти и восприятия новой информации;\n· поддержание высокой активности и отличной координации движений;\n· увеличение некоторых долей головного мозга, спровоцированное избытком гормонов;\n· повышение активности эндокринной системы и нормализация обмена веществ.\nИ это далеко не весь список положительных изменений, происходящих в организме будущей мамы при кормлении и вынашивании малыша. Берегите себя и помните, что беременность благоприятно сказывается на состоянии вашего здоровья!\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О приеме витаминов и лекарственных препаратов во время беременности'
        },
        {
            'insert': '\nПодавляющее большинство женщин имеют скрытый или явный дефицит каких-либо микронутриентов, одна из важнейших задач — выявить его и принять необходимые меры ещё до наступления беременности.\nТочная диагностика — лабораторный анализ уровней витаминов и минералов — сложна, затратна и не всегда доступна (если манифестную анемию можно верифицировать по общему анализу крови, то, например, концентрацию магния приходится определять в слюне, ногтях, волосах или эритроцитах с помощью дорогостоящих методик).\nОбщие проявления нехватки практически любого микронутриента включают необъяснимые другими причинами слабость, повышенную утомляемость, сниженную физическую и умственную работоспособность, эмоциональную подавленность и т.п. Часто эти неспецифические симптомы связаны с дефицитом микронутриентов при недоедании (например, из-за сниженного аппетита), хронических заболеваниях желудочно-кишечного тракта, особенно сопровождающихся диареей (они снижают всасывание и повышают выведение) и увлечении разнообразными диетами.\nНехватка конкретного питательного вещества, как правило, имеет более специфические проявления. Так, например, заподозрить железодефицитную анемию позволяют обильные менструации, кровоточивость дёсен, бледность кожи и слизистых оболочек. Признаками недостаточного потребления йода и связанных с ним нарушений функции щитовидной железы часто становятся повышенная потливость, перепады настроения, необъяснимые изменения массы тела.\nО нехватке кальция и/или метаболически связанного с ним витамина D могут свидетельствовать судороги и слабость, онемение пальцев, изменения текстуры волос и ногтей. Заподозрить дефицит магния позволяют повышенная нервная возбудимость, расстройства сна и мышечные спазмы. Признаки недостатка цинка могут включать разнообразные изменения слизистых оболочек (сухость, изъязвления), кожи, ногтей и волос, а также частые простудные заболевания.\nДефицит витамина В12, как правило, проявляется анемией (не всегда сопровождающейся недостатком железа), слабостью, онемением конечностей, расстройствами координации и когнитивными нарушениями. Нехватку остальных витаминов группы В можно заподозрить по кожным проявлениям, отёкам, снижению зрения.\nПомня о наиболее распространённых дефицитах микронутриентов, можно заподозрить их на приёме: достаточно беглого опроса и осмотра. При обнаружении признаков какого-либо из этих состояний необходимо более детальное обследование с привлечением смежных специалистов и при необходимости восполнение запасов недостающего вещества.\nЖенщины, особенно планирующие зачатие, нуждаются в дополнительных источниках микронутриентов. По имеющимся рекомендациям ВОЗ абсолютно всем, начиная с периода прегравидарной подготовки, показан приём препаратов фолиевой кислоты и железа — их не хватает подавляющему большинству людей, а дефицит чреват тяжёлыми дефектами развития плода и даже внутри- утробной гибелью24. Существуют данные о связи потребления омега-3 полиненасыщенных жирных кислот и уровня риска преэклампсии, преждевременных родов и низкой массы тела при рождении, так что добавка этих веществ к рациону также целесообразна. Остальные витамины и минералы следует принимать в виде препаратов только при их дефиците.\nБеременной пациентке рекомендовано назначить пероральный прием фолиевой кислоты на протяжении первых 12 недель беременности в дозе 400 мкг в день. Назначение фолиевой кислоты на протяжении первых 12 недель беременности снижает риск рождения ребенка с дефектом нервной трубки (например, анэнцефалией или расщеплением позвоночника).\nБеременной пациентке рекомендовано назначить пероральный прием препаратов йода (калия йодида) на протяжении всей беременности в дозе 200 мкг в день.\nБеременной пациентке группы высокого риска ПЭ при низком потреблении кальция (менее 600 мг/день) рекомендовано назначить пероральный прием препаратов кальция на протяжении всей беременности в дозе 1 г/день.\nНазначение препаратов кальция на протяжении всей беременности у пациенток группы высокого риска ПЭ снижает риск развития данного заболевания. Беременной пациентке группы высокого риска гиповитаминоза витамина D рекомендовано назначить пероральный прием витамина D на протяжении всей беременности в дозе 10 мкг (400 МЕ) в день.\nВ группе высокого риска гиповитаминоза витамина D его назначение снижает риск таких акушерских осложнений, как ПЭ, ЗРП и ГСД. К группе высокого риска гиповитаминоза витамина D относятся женщины с темной кожей, имеющие ограничения пребывания на солнце, со сниженным уровнем потребления мяса, жирной рыбы, яиц, с ИМТ до беременности ≥30 кг/м.\nОдин из важнейших микронутриентов — магний, — как правило, остаётся без заслуженного внимания. При этом 30% жителей России получают менее 70% от суточной потребности этого элемента. Это неудивительно, поскольку в рационе среднестатистического россиянина продуктов, богатых этим элементом (длиннозёрного коричневого риса, кукурузы, шпината, бобов, картофеля с кожурой, орехов, бананов, магниевой минеральной воды), недостаточно для поступления необходимых 320 мг/сут. Беременным этого микронутриента нужно ещё больше — 400 мг/сут, что связано с повышенным расходом на рост матки, формирование плаценты и нужды плода. Магний необходим для процессов деления клетки, что особенно важно на ранних этапах эмбриогенеза, а также при инвазии трофобласта и формировании плаценты. Кроме того, магний участвует в энергетическом обмене — в клетках наибольшее его количество сосредоточено в митохондриях, где он служит кофактором ряда ферментов и образует стабильные комплексы с АТФ. Соответственно, наибольшую магниевую потребность испытывают органы с интенсивным энергообменом — мозг, миокард, плацента, матка и скелетные мышцы (если не считать кости, в которых находится до 60% запасов этого элемента, обеспечивающего прочность ткани и абсорбцию кальция). Ещё одна важная роль магния — обеспечение фазы покоя при проведении нервных импульсов и участие в синтезе ключевых нейромедиаторов. И этим процессы с его участием не исчерпываются: среди них регуляция сосудистого тонуса и поддержание нормального артериального давления, профилактика чрез- мерного тромбообразования и многое другое. Этот элемент присутствует в качестве кофактора примерно в 500 белках, в числе которых более 300 ферментов, что подтверждает многообразие его физиологических функций.\nСовременное развитие нутрициологии и диететики — путь к формированию ответственного отношения к здоровью и приобретение новых знаний о его поддержании. Роль питания сложно переоценить, при этом каждый его компонент важен и не должен быть забыт. Как показывают исследования, плод нуждается в сбалансированном поступлении питательных веществ, и заботиться об этом, конечно, должна будущая мать. Задача акушера-гинеколога — помочь ей сформировать правильный рацион и компенсировать тот или иной дефицит лекарственными препаратами.\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О вакцинации во время беременности'
        },
        {
            'insert': '\nБеременность не является противопоказанием к проведению вакцинации. Вакцинацию не желательно проводить в I триместре беременности. А вот во II и III триместрах можно и даже нужно. Если будущая мама сделает прививку от гриппа, то это обеспечит детям первых месяцев жизни эффективную защиту против этого вируса. Саму же женщину прививка от гриппа защитит от осложнений, которые могут привести к неблагоприятным последствиям как для самой беременной, так и для ее будущего ребенка.  \nВ экстренных ситуациях при укусе животного допускается введение беременной женщине вакцины против бешенства. Это жизненно необходимо, так как развитие инфекции в 100% случаев приводит к летальному исходу.\nВакцина против бешенства не содержит живых вирусов, поэтому ее применение безопасно. Но есть и вакцины, которые категорически противопоказаны беременным женщинам.\nТак, нельзя вакцинировать будущих мам против туберкулеза (БЦЖ), менингококковой инфекции, кори, краснухи, паротита (КПК), ветряной оспы, брюшного тифа.Вакцинация против дифтерии и столбняка проводится взрослому населению один раз в десять лет. Поэтому если в течение последних десяти лет женщина не делала прививки против этих инфекций, то при планировании беременности ей необходимо сделать очередную ревакцинацию препаратом АДСМ (дифтерийно-столбнячный анатоксин).\nКроме того, в случае травмы, укуса животными проводится экстренная профилактика столбняка.За полгода до беременности рекомендуется провести вакцинацию против гепатита В. Вакцина против гепатита В также не содержит живого вируса, поэтому она безопасна для плода. Во время беременности вакцинация против гепатита В рекомендована только женщинам, входящим в группу высокого риска. Например, сотрудницам салонов красоты. За 3-6 месяцев до планируемой беременности рекомендуется провести вакцинацию против краснухи, кори, паротита (КПК). Ведь, например, корь, перенесенная во время беременности, повышает риск преждевременных родов. У женщины может родиться мертвый ребенок.\nКраснуха у беременной часто становится причиной развития аномалий плода. Эпидемический паротит, перенесенный в первом триместре беременности, также самым печальным образом может отразиться на еще не родившемся ребенке и даже привести к его гибели в утробе матери.\nЗа месяц до наступления беременности рекомендуется провести вакцинацию против ветряной оспы. Это тоже очень грозная инфекция, которая может вызвать патологию зрения, а также задержку умственного и физического развития ребенка. \n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О необходимых исследованиях во время беременности'
        },
        {
            'insert': '\nКалендарь медицинского наблюдения'
        },
        {
            'attributes': {
                'header': 1
            },
            'insert': '\n'
        },
        {
            'insert': '  Женщины во время беременности ведут себя по-разному. Одни очень беспокоятся за здоровье малыша, поэтому спешат сделать полное обследование своего организма, включая самые экзотические виды лабораторных обследований. Другие, наоборот, не считают нужным посещать поликлинику и сдавать анализы, если нормально себя чувствуют. В данном случае важно найти золотую середину, что позволит контролировать состояние будущей мамочки и растущего ребеночка, и при необходимости немедленно предпринять меры для его улучшения.\nВ настоящее время существует регулируемый на законодательном уровне минимум обязательных анализов и обследований, которые беременная женщина должна пройти во время беременности. Этот список может изменяться в зависимости от состояния здоровья пациентки, наличия у нее хронических заболеваний или появления тревожных симптомов со стороны плода. Решение об изменении плана медицинского наблюдения в подобных случаях принимает лечащий врач. Наблюдение беременных осуществляется согласно приказа МЗ 1130н от 20.10.2020г.\nОбследования в первом триместре беременности'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'Врачи женской консультации рекомендуют будущим мамочкам первый раз посетить гинеколога и встать на учет в женской консультации в срок до 12 недели их беременности. На первой консультации специалист заводит «Индивидуальную карту беременной и родильницы» по которой будущая мама будет наблюдаться в женской консультации, а затем оформляет и выдает каждой пациентке обменную карту – с которой она пойдет в выбранный родильный дом) и список лабораторных обследований, которые она должна пройти в обязательном порядке. Для тех будущих мам, которые начнут наблюдаться в женской консультации до 12 недель беременности, положено единовременное пособие от государства (см. сайт Фонда Социального Страхования РФ, виды и размеры пособий). Пожалуйста, учитывайте, что акушерский срок беременности рассчитывается не со дня зачатия, а с первого дня последней менструации.\nВажно помнить, что для полного оформления обменной карты нужно будет пройти ряд специалистов. Поэтому не следует затягивать с визитом и уже после планового посещения гинеколога следует отправиться на обследование к терапевту, хирургу, эндокринологу, отоларингологу, стоматологу и окулисту (нужных специалистов выберет лечащий врач на основании оценки медицинской истории беременной женщины). К прохождению данных специалистов нужно отнестись со всей серьезностью, ведь именно от их заключения во многом зависит план ведение конкретной беременности.\nКроме этого, в первом триместре беременности каждая женщина должна сдать ряд анализов, среди которых:\nпривычный всем общий анализ крови;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'важное определение группы и резус-фактора, если у мамы окажется отрицательный резус-фактор, нужно будет проверить резус-фактор будущего отца;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'биохимический анализ крови;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'определение свертываемости крови;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'исследование на наличие антител к краснухе (при необходимсти расширенного обследования мжет быть назначен комплекс , TORCH-инфекциям, в частности, токсоплазме, цитомегаловирусу, герпетической инфекции);'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'анализы на сифилис, гепатиты В и С, ВИЧ;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'мазок на влагалищную флору и посев на микрофлору из цервикального и чувствительность к антибиотикам;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'посев мочи на микрофлору  и чувствительность к антибиотикам;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'ЭКГ, УЗИ почек.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Консультации специалистов (терапвт, офтальмолог,ЛОР, стоматолог, а так же других узких специалистов при наличии показаний)'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Список может быть как шире, так и уже, более подробную информацию можно получить у лечащего врача. При постановке на учет врач проводит общий и гинекологический осмотр беременной женщины с занесением полученных данных в ее обменную карту.\nОшибочно полагать, что какие-то из перечисленных выше анализов являются необязательными или их можно избежать. Только полное исполнение рекомендаций врача по объему обследования, позволит оценить состояние здоровья будущей матери, ведь ей предстоит достаточно напряженный период, который также закладывает и основу здоровья ребенка в будущем.\nЕсли во время беременности женщина отказывается сдавать кровь на ВИЧ, тогда данный анализ проведут малышу сразу после рождения. Очень важно оценить статус по ВИЧ инфекции как можно раньше до родов. К сожалению, многие женщины не знают о своем статусе по ВИЧ инфекции, а ведь в случае правильного выполнения профилактики передачи от матери к ребенку, риск рождения малыша с ВИЧ инфекцией практически равен нулю.\nА как обстоят дела с другими анализами из обязательного списка? Своевременно сделанные исследования на TORCH-инфекции помогут вовремя диагностировать заболевание. Общий и биохимический анализ крови даст возможность оценить состояние здоровья женщины, исключить анемию беременности и вести контроль уровня форменных элементов крови. Анализ мочи необходим для оценки функции почек.\nОбычно врач-гинеколог в женской консультации приглашает на прием беременных женщин в первом триместре с частотой 1 раз в 4 недели.\nПервый триместр беременности подходит к концу? Самое время для ультразвукового исследования. УЗИ на 11-13 неделе позволяет:\nопределить точные сроки гестации;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'дать заключение о количестве плодов в матке;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'диагностировать возможные проблемы формирования нервной трубкой плода, дефекты конечностей и брюшной стенки.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Кроме того, в первый скрининг входит определение особых, связанных с беременностью белков (РАРР-А и βХГЧ) с помощью анализа крови. На основание результатов УЗИ и анализа крови на эти белки, врач принимает решение о наличие или отсутствие риска врожденных аномалий развития у плода и может направить беременную на консультацию к врачу-генетику.\nВторой триместр беременности и необходимые анализы и исследования'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'С 14 по 28 неделю беременности женщина пребывает во втором триместре. В это время врач назначает ей обследования, которые помогают оценить состояние будущего ребенка, определить наличие отклонений в развитии. На 16-18 неделе специалисты могут порекомендовать (особенно беременным старше 35 лет, женщинам с неблагоприятным акушерским анамнезом и т.п.) пройти тест с исследованием уровней альфа-фетопротеина (АФП), хорионического гонадотропина (ХГ) и неконъюгированного эстриола (НЭ), которые являются маркерами хромосомных аномалий. Повышенные концентрации этих веществ могут указывать на риск наличия генетических отклоненийй у ребенка. В случае если эти показатели повышены, после проведения УЗИ женщина будет направлена на медико-генетическое консультирование.\nПосле 18 недели гестации (беременности) женщине необходимо пройти второе плановое ультразвуковое исследование. Эта процедура дает возможность:\nс уверенностью определить пол будущего крохи;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'оценить развитие органов и систем ребенка и диагностировать аномалии внутриутробного развития плода;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'оценить качество околоплодных вод и измерить их количество;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'выявить предлежание плаценты.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Помимо всего, женщине необходимо каждые две-три недели посещать врача с консультативным визитом, и каждый раз сдавать анализ крови и мочи. Это следует делать для своевременной диагностики развития анемии или нарушения работы почек. На каждом визите врач будет оценивать ваш вес, объем живота, высоту стояния дна матки и ряд других важных показателей. Кроме того, для исключения диабета беременных во втором триместре может быть выполнен тест на толерантность к глюкозе.\nТретий триместр беременности: анализы после 28 недели'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'С 30 недель беременности работающие женщины имеют право уходить в декретный отпуск. Для его оформления им понадобится посетить женскую консультацию и собрать необходимые документы. Именно на этом сроке гестации рекомендуется пройти третье по счету и последнее при нормальном течении беременности УЗИ с доплерометрией, которое позволяет оценить:\nсостояние здоровья плода с определением патологий, которые невозможно было диагностировать в первом и втором триместре;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'рост и развитие ребенка, а также наличие задержки внутриутробного развития (если имеется);'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'точное месторасположения плаценты, пуповины и малыша;'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'количество околоплодных вод.'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Доплерометрия дает возможность оценить кровоток по сосудам пуповины и плаценты. Для чего необходим допплер? Все очень просто. По состоянию кровотока можно судить о качестве внутриутробного питания малыша и предположить его гипоксию (недостаток кислорода). Кроме того, врач может дополнительно назначить кардиотокографию.\nБлиже к 36 неделе беременная женщина еще раз сдает анализы крови на ВИЧ, гепатиты и сифилис, а также мазок из влагалища и биохимический тест крови. Если все эти анализы окажутся в норме, тогда женщина может спокойно ожидать наступления родов, посещая своего врача каждую неделю. В случае наличия отклонений по результатам тестов, пациентку берут под контроль или госпитализируют для дальнейшего обследования, лечения и определения дальнейшей тактики ведения и родоразрешения.\n Не стоит забывать, что своевременные обследования помогают предупредить развитие сложных вариантов течения беременности и позволяют диагностировать заболевания на ранних сроках, когда они легче поддаются коррекции. Это особенно важно в период беременности, поскольку дает возможность сохранить здоровье будущего малыша и исключить риск осложнений у матери.\n\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'О понятии нормальной беременности, и жалобах, характерных для каждого триместра беременности'
        },
        {
            'insert': '\nО понятии нормальной беременности и жалобы, характерные для\nнормальной беременности в каждом триместре беременности. правильное питание и поведение во время беременности. В этой статье разберём, что считается нормой при беременности.\nСогласно определению, данному в клинических рекомендациях, Нормальная беременность – одноплодная беременность плодом без генетической патологии или пороков развития, длящаяся 37-41 недель, протекающая без акушерских и перинатальных осложнений.\nЗачастую во время беременности появляются симптомы, которые пугают будущую маму. Давайте разберёмся, какие изменения считаются нормой беременности.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Тошнота и рвота.'
        },
        {
            'insert': '\nС этим симптомом знакома каждая 3я беременная. Если рвота не более 2-3 раз в сутки, чаще натощак, не нарушает общего состояния – это физиологический признак беременности. Выход – кушать чаще, малыми порциями, исключить из рациона жирные, жареные блюда, шоколад, острые блюда, газированные напитки, кофе, крепкий чай. Тошнота и рвота прекращаются обычно к 16-20 неделям. При\nплохом самочувствии – обратитесь к врачу.\n\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Болезненность молочных желёз'
        },
        {
            'insert': ' в 1м триместре беременности.\nГормональные изменения приводят к отёчности и нагрубанию молочных желёз. Постепенно болевые ощущения пропадут. Подберите удобное бельё.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Боли внизу живота.'
        },
        {
            'insert': '\nМогут возникать при натяжении связочного аппарата матки во время её роста (ноющие боли или внезапная колющая боль внизу живота). А после 20 недель –тренировочные схватки. Длительность до 1 минуты, не регулярные. Разобраться где норма, где патология поможет врач на приёме.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Изжога.'
        },
        {
            'insert': '\nЧастый симптом в 3м триместре беременности. Чем помочь себе: не\nпринимать горизонтальное положение после еды, кушать маленькими порциями, соблюдать диету из предыдущего пункта, носить свободную одежду, не сдавливающую область желудка.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Запоры'
        },
        {
            'insert': '.\nБеременные часто сталкиваются с запорами. Их возникновение также связано с гормональными изменениями в организме женщины. Включите в рацион больше зелени, овощей и фруктов. Не помогает, обратитесь к врачу.  \n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Геморрой.'
        },
        {
            'insert': '\nПроявляется у 8-10% женщин. Как помочь себе: справиться с запорами – кушать больше клетчатки, пить достаточно воды, не забывать о физической активности. Не наступает облегчение, обратитесь к терапевту или проктологу.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Варикозная болезнь '
        },
        {
            'insert': 'развивается у 20-40% женщин.\nПричина: повышение венозного давления, тонус стенки сосудов снижен.\nПоможет: ношение компрессионного трикотажа. При выраженном расширении вен нижних конечностей обратитесь к сосудистому хирургу.\nБолее обильные выделения из влагалища без дискомфорта, зуда – норма беременности.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Боль в спине.'
        },
        {
            'insert': '\nБольшинство беременных сталкиваются с этой проблемой на 5-7 месяце беременности. Причины: растёт нагрузка на спину, смещается центр тяжести, снижается тонус мышц. Увеличьте физическую активность.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Боли в лобке.'
        },
        {
            'insert': '\nДостаточно редкая проблема. Появляется на поздних сроках беременности. Носите бандаж.\nПокалывание, жгучая боль, онемение руки, снижение чувствительности, работоспособности кисти.\nВот с таким неожиданным симптомом сталкиваются до 62% беременных.\nМы убедились, что многие симптомы нормальной беременности можно сгладить благодаря правильному рациону и умеренной физической нагрузке. Ещё несколько рекомендаций по питанию:\nИсключение из рациона жирных, жареных блюд, шоколада, острых блюд, газированных напитков, кофе, крепкого чая поможет снизить риски возникновения тошноты и изжоги.\n\nОбратите внимание, что вегетарианство во время беременности увеличивает риск задержки роста плода.\nБольшое количество кофеина (более 300 мг/сут) увеличивает риск\nпрерывания беременности и рождения маловесных детей.\nОграничьте потребление рыбы, богатой метилртутью (например, тунец, акула, рыба-меч, макрель), так как может вызвать нарушение развития плода.\nИзбегайте потребления непастеризованного молока, созревших мягких сыров, паштета и плохо термически обработанных мяса и яиц, так как эти продукты являются источниками листериоза и сальмонеллеза.\nЗдоровое питание во время беременности характеризуется достаточной калорийностью и содержанием белка, витаминов и минеральных веществ, получаемых в результате употребления в пищу разнообразных продуктов, включая зеленые и оранжевые овощи, мясо, рыбу, бобовые, орехи, фрукты и продукты из цельного зерна.\n\n'
        }
    ]
};
        },
        abortInfo() {
            return {
    'ops': [
        {
            'insert': 'О внутриутробном развитии ребенка по неделям беременности с описанием его способностей (начало сердцебиения, начало двигательной активности, открывания глаз, сосательных движений и др.)'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'С момента зачатия, когда сливаются две половые клетки – мужская и женская, очень многое уже предопределено. \nВ этот момент определяется пол малыша (слияние хромосом по типу ХХ гарантирует развитие девочки, а XY – мальчика).\nДлится беременность в среднем 40 акушерских недель. Эмбриональные недели – время, которое малыш фактически существует (с момента зачатия), а акушерскими считают время от первого дня последней в цикле зачатия менструации.\nПосле имплантации начинается эмбриональный период, который длится 8 недель, с 10 акушерской недели начинается фетальный период. В эмбриональном закладываются все органы и системы, в фетальном они лишь растут и увеличиваются в размерах.\nФакторы, влияющие на развитие плода, многогранны: это и здоровье женщины, и наследственность родителей, и вредные привычки (курение, алкоголь), и состояние экологии в местности проживания будущей мамы, и ее социальное положение (питание, обеспеченность витаминами), и доступность медицинской помощи и многое другое.\n\nПервая\nМалыша еще нет. Совсем нет. У женщины начались месячные и, возможно, она пока даже не планирует беременности. В организме идет процесс очищения полости матки от разросшегося в прошлом менструальном цикле эндометрия. К концу недели месячные завершаются, на гормональном уровне начинают происходить изменения – вырабатываются фолликулостимулирующие гормоны, начинается лютеиновая фаза.\nВторая\nОплодотворенная яйцеклетка, движимая ворсинками внутри маточных труб, начинает постепенно спускаться в полость матки.\nТретья\n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'Когда плодное яйцо погружается в эндометриальный слой, ворсинки внешнего слоя бластоцисты соединяются с кровеносными сосудами женщины, зародыш начинает питаться – получать все, что ему нужно для развития из материнской крови.'
        },
        {
            'insert': '\n\nЧетвертая\nУ женщины еще не началась задержка, а малыш-бластоциста уже стал эмбрионом и приобрел первые характеристики: его вес – около 0.5 грамма, рост – менее 1 миллиметра. Формируется три зародышевых лепестка. Наружный позднее станет кожными покровами ребенка, средний ляжет в основу поэтапного образования сердца и сосудов, половых органов, костей и мышечной ткани, а внутренний будет органами пищеварения, дыхания и мочеполовой системы.\nПоявляется зачаток спинного мозга. Сам малыш выглядит как шарик. На этом сроке его можно поздравить с первым самостоятельным достижением: он научился добывать кислород из материнской крови с помощью хориона.\n \n\nПятая\nС этой недели у него начнет биться сердце. Пока оно двухкамерное, процесс формирования отделов еще идет, но к концу 5 недели оно начнет ритмично сокращаться. Продолжается деление клеток и закладка органов. Рост эмбриона на этой неделе – уже около 1.5 миллиметров, вес – в пределах 1 грамма. Начинают закладываться половые клетки. \n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'Эта неделя считается одной из самых важных, поскольку сейчас у ребенка закладывается прообраз нервной системы – трубка, которой предстоит стать головным и спинным мозгом. Этапы этого процесса очень сложны.'
        },
        {
            'insert': '\n\nШестая\n \nНа этом сроке у ребенка начинается формирование иммунной системы – закладывается вилочковая железа. Сердечко уже стучит, правда, неравномерно. Начинается формирование рук, на месте, где будут глазки, появляются темные точки-выступы, а там, где положено быть ушкам – небольшие ямочки. Малютка пока не умеет двигаться, но для того, чтобы овладеть этим навыком, ему понадобится всего около недели.\n\nСедьмая\n«Все для нервной системы!». Ее формирование сейчас – самый значимый и важный процесс. И идет он очень быстро. Головной мозг отделился от спинного, начинает появляться мозжечок. Малыш получает возможность двигать головкой.\n\nВосьмая\nСходство у эмбриона с человеком все более заметно – сформировались все части тела. Закладка органов завершилась, начинается рост.\n\nДевятая\nЗавершился эмбриональный период развития и начался фетальный. Малыш именуется плодом и так будет до самых родов.\n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'Вес малютки – около 10 граммов, рост – от 6 до 7 мм. По размерам он напоминает приличных размеров бусину или небольшую сливу. Продолжается развитие и разветвление нервной системы.'
        },
        {
            'insert': '\n\nДесятая\n \nГоловной мозг имеет два полушария. К концу недели малыш начинает подносить ручки ко рту, трогать свое личико. Почки активно производят мочу, малыш заглатывает воды и писает, воды обновляются каждые 3.5-4 часа. Головка округляется.Появились губы и веки, заложены носик и ушные раковины. Теперь у малыша есть шея, и он начинает поворачивать головку.\n\nОдиннадцатая\nВесит ребенок более 15 граммов, его рост – около 8 сантиметров. По размерам он напоминает среднюю грушу. Анатомия плода совершенна, есть все, но только очень маленькое и функционально незрелое.\n\nДвенадцатая\nРост малыша достигает 9-10 сантиметров, а вес – примерно 20 граммов. Эти параметры сопоставимы с лимоном среднего размера. Тело все еще непропорциональное – голова крупная, а ножки остаются короче рук. Зато глазки полностью встали на положенное им место, что сразу придало ребенку вполне человеческий облик. Завершилось формирование век, но открывать глаза малыш пока не может.\nУшные раковины растут, и на этой неделе появляются мочки. Активно начинает расти и нос. Теперь даже на размытом снимке УЗИ плохого качества виден рельеф лица, и обладатели больших носов уже отличаются внешне от курносых ровесников. Спинной мозг, который «ведал» нервными импульсами, начинает передавать полномочия головному.\n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'Малыш освоил сосательный рефлекс. Он отлично различает вкусовые оттенки – околоплодные воды после съеденного мамой шоколада ему уже сейчас нравятся куда больше, чем после съеденного чеснока.'
        },
        {
            'insert': '\nКишечник, формирование которого завершено, начинает осваивать первые мышечные сокращения, которые станут перистальтикой. У мальчиков на этой неделе появляется пенис, а у девочек – половые губы, но пока органы еще малы, и не всегда есть возможность рассмотреть пол ребенка на УЗИ. Малыш активно двигается (даже во сне), он уже умеет сосать свой пальчик.\n\nТринадцатая\nМалыш увеличивает вес почти ежедневно. Теперь по размерам он напоминает солидную луковицу, его рост – около 11 сантиметров, вес – около 30 граммов.\nВ головном мозге активно растет мозговое вещество. Малыш научился вздрагивать, обнимать себя за плечики. На этой неделе малыш обзаводится ребрами. Сформированы все органы дыхательной системы, и грудная клетка начинает расширяться. Формируются голосовые связки.\n\nРазвитие во втором триместре\nЧетырнадцатая\nРост малыша сейчас – 12-14 сантиметров, а вес достигает 50 граммов. По размерам он напоминает небольшой гранат.\nГоловной мозг достаточно созрел, чтобы взять контроль над органами и системами на себя.\nСердце малютки перекачивает до 25 литров крови в сутки. Кроха на этой неделе научился улыбаться, правда, неосознанно, рефлекторно.\n\nПятнадцатая\nМалыш становится больше. Его размеры сопоставимы с яблоком – рост составляет 16 сантиметров, а вес – около 100 граммов.\nВ головном мозге появляются первые извилины, и кроха заметно «умнеет». Мозжечок уже лучше координирует движения конечностей.\nШестнадцатая\nРост малыша – 17 сантиметров, теперь весит уже до 130 граммов. Завершила формирование шея, теперь плод получил возможность держать головку прямо, а не прижатой к груди. Начали работать мышцы, отвечающие за движения глаз. Появились ресницы. Лобик начинает выступать вперед, что делает малыша все более похожим на человечка.\nЗавершилось формирование мышечного каркаса, теперь все мышцы лишь растут. На этой неделе начинают полноценно трудиться железы внутренней секреции.\n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'Семнадцатая'
        },
        {
            'insert': '\nВесит малыш около 160 граммов, а его рост достигает 19-20 сантиметров, у него сформированы все черты лица.\nСчитается, что на этой неделе малыш начинает видеть сны. Нервная система развита настолько, что малыш получил возможность координировать движения простые и комбинированные.\nПоявляется инстинкт самосохранения.\n\n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'Восемнадцатая'
        },
        {
            'insert': '\nВесит малыш сейчас до 220 граммов, его рост – около 22 сантиметров.\nКора головного мозга формируется очень интенсивно. Завершился процесс минерализации костей черепа и больших парных костей. Ножки ребенка впервые за всю его внутриутробную историю превысили по длине ручки.\nРебенок заглатывает до 400 мл амниотической жидкости в сутки. Так он тренирует свою пищеварительную систему и органы выделения мочи.\n\nДевятнадцатая\nСейчас его рост – около 24 сантиметров, а вес – около 300 граммов. Кожные покровы начинают разглаживаться, но пока изменения минимальны – подкожного жира образовалось не так много. В первую очередь он откладывается в области шеи, на лопатках и на пояснице. Сформированы брови и ресницы. Малыш шевелится давно, но именно сейчас он достиг размеров, при которых женщина может начать его ощущать.\nНа этой неделе малыша можно поздравить с обретением полноценного слуха.\nДвадцатая\nЭтот срок – середина беременности. Сейчас его размеры: рост – около 26 сантиметров, вес – 350 граммов. Кожа на этой неделе становится четырехслойной.\n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'На этой неделе малыш начинает предпринимать первые попытки приоткрыть глаза. Формируется рефлекс моргания. С этого срока в полную силу начинает работать иммунная система.'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'italic': true
            },
            'insert': 'Двадцать первая'
        },
        {
            'insert': '\nВес малыша составляет уже более 400 граммов, а рост может достигать 28 сантиметров. Кожа малютки перестала быть ярко-красной и лиловой. Первый слой подкожного жира, хоть он еще и тонкий, преображает внешность крохи.\nНа долю головы в пропорциях тела теперь отводится около четверти. Появился животик. Малыш все больше напоминает новорожденного.\nНервная система развивается, каждую секунду появляются тысячи новых клеток-нейронов.\n\nО высокой вероятности бесплодия после искусственного аборта'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'Частой причиной дальнейшего бесплодия является процесс искусственного прерывания беременности (аборт).\nПосле аборта вероятность бесплодия достаточно высока, в процентном соотношении бесплодие после аборта достигает 15 %, даже при условии отсутствия осложнений при аборте. Медики отмечают частые случаи бесплодия именно при первом аборте (аборте при первой беременности), с последующим возникновением различных нарушений репродуктивных функций у женщин (осложнениях при беременности, выкидышах, бесплодии).\nМетодики выполнения абортов:\nМедикаментозный аборт – осуществляется до шестой недели беременности, благодаря лекарственным препаратам, провоцирующим выкидыш плода. Исследованием УЗИ предварительно исключается внематочная беременность, так как при таком диагнозе проведение медикаментозного аборта строго противопоказано в связи с повышенной вероятностью серьезных осложнений (кровотечения при разрыве маточной трубы), жизни женщины в таком случае будет угрожать опасность. Медикаментозный аборт проводится при обязательном присутствии врача. После принятия женщиной препарата, за ней проводится наблюдение медперсонала (около двух часов). Спустя некоторое время появляется кровотечение – это свидетельствует о прерывании беременности.\nЧтобы проконтролировать результаты, необходимо повторное УЗИ.\nПротивопоказания к медикаментозному аборту:\n• Наличие воспалительных процессов малого таза.\n• Появление инфекционных заболеваний.\n• Внематочная беременность.\n• Нарушение свертываемости крови.\nОднако прерывание беременности методом медикаментозного аборта не дает 100 % гарантии успеха. Щадящая процедура данного вида аборта и относительно небольшой процент развития бесплодия при медикаментозном аборте дают надежду на успешное решение проблемы. Но процент бесплодия повышается при появлении нежелательных последствий:\n• возникновение сильного кровотечения после аборта;\n• вероятность непредвиденной реакции организма на принятые препараты;\n• ановуляция;\n• гормональный сбой;\n• нарушения менструального цикла;\n• воспалительные заболевания матки;\n• воспаление яичников, придатков при неполном отторжении тканей плода.\nВакуумный, или мини-аборт. Проводится до шестой недели под полной или местной анестезией. Используется вакуумный аспиратор, контроль ведется УЗИ-аппаратом. Врач наблюдает за пациентом, перенесшим вакуумный аборт на протяжении 2–3 часов. В послеабортный период около трех недель нельзя испытывать переохлаждение, физические нагрузки, принимать ванны. Требуется временно исключить сексуальные отношения.\nХирургический аборт. Возможен до 12-й недели беременности. Необходима тщательная подготовка к аборту: сдача общего анализа крови, а также анализов крови на ВИЧ, сифилис и гепатит. Хирургический аборт проводится при помощи специальных инструментов с удалением плода и последующим выскабливанием полости матки. Этот наиболее сложный вид аборта отличается повышенными рисками и травмоопасностью.\nПричины бесплодия при хирургическом аборте:\n• Развитие воспалительных процессов при проведении процедуры.\n• Инфицирование полости матки.\n• Нарушение правил интимной гигиены во время послеоперационного периода.\n• В тканях матки образуются рубцы и спайки, что способствует возникновению непроходимости маточных труб и эндометриоза.\n• Травмы шейки матки хирургическими инструментами (возможны серьезные осложнения при последующих родах).\n• Получение психологической травмы (депрессивное состояние).\n• Гормональный фон нарушается (в результате резкого нарушения гормонального фона организма женщины после аборта существует вероятность развития эндокринного бесплодия и прекращения овуляций).\n\n\nО негативном влиянии искусственного аборта на организм женщины'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'Искусственное прерывание беременности или медицинский аборт – прерывание беременности и изгнание продуктов зачатия из полости матки до сроков жизнеспособности плода с использованием медикаментозных или хирургических методов.\nМедикаментозный метод – прерывание беременности и изгнание продуктов зачатия из полости матки до сроков жизнеспособности плода с использованием медикаментозных методов. Данный метод является безопасным и эффективным методом прерывания беременности в амбулаторных условиях. Эффективность метода на сроке беременности до 10 недель составляет 94-98%.\nЛюбой аборт, как серьезное медицинское вмешательство, неизбежно несет за собой риск осложнений. Некоторые негативные последствия и осложнения после аборта могут быть характерными для определенного метода прерывания беременности.\nПри медикаментозном аборте\nМедикаментозное прерывание беременности считается наиболее безопасным, однако и оно несет в себе риски.\n• маточные кровотечения, требующие проведения инструментального опорожнения матки в стационаре (вакум-аспирации полости матки) и применения сокращающих матку средств;\n• неполный аборт (остатки плодного яйца удаляются также с помощью вакуум-аспирации полости матки в стационаре);\n• инфекционные осложнения (риск развития их составляет менее 1% случаев);\n• прогрессирование беременности в ситуации, когда не произошло отторжение плодного яйца.\nПри вакуумном и хирургическом аборте\nРанние осложнения\nВозникают непосредственно во время процедуры и в первые сутки послеоперационного периода\n• Кровотечение во время процедуры – может случиться при нарушении свертывающей системы крови у пациентки, а также при отсутствии должного сокращения стенок матки в ходе процедуры. Плохо сокращаются стенки много раз рожавшей или перенесшей большое количество абортов матки (неполноценная мышечная ткань). Такое состояние требует применения больших доз сокращающих матку препаратов, в очень редких случаях при невозможности остановки кровотечения матку удаляют. При нарушениях свертывающей системы крови проводят возмещение факторов свертывания путем применения препаратов или переливания крови.\n• Перфорация матки (случайный прокол) при проведении вакуумного аборта возникает редко, так как не используются острые инструменты. Тем не менее, хоть и редко, но такое может произойти при расширении шейки матки или исследовании длины полости матки перед процедурой с помощью маточного зонда.\n• При проведении выскабливания с помощью острой кюретки риск перфорации стенки матки увеличивается. Острым инструментом можно пройти через стенку матки и ранить прилежащие петли кишечника, мочевой пузырь. В данном случае операция аборта заканчивается переходом на полостную операцию (для ушивания раны кишечника, к примеру, или остановки кровотечения из перфорированной стенки матки).\n• Непосредственно при проведении процедуры может возникнуть аллергическая реакция на препараты для наркоза.\n• При расширении шеечного канала может быть травмирована шейка матки.\nПоздние осложнения\nМогут наблюдаться в течение недели, нескольких месяцев после операции:\n• После проведения аборта в норме кровянистые выделения продолжаются еще несколько дней. Иногда после аборта и расширения шейки матки шеечный канал закрывается слишком рано, кровь скапливается в полости матки и возникает так называемое осложнение гематометра. Такое осложнение можно заподозрить, если на следующий день после проведения аборта женщина жалуется на резкие боли внизу живота и отмечает прекращение кровянистых выделений из половых путей в первый же вечер. Гематометра также видна на УЗИ (полость матки забита сгустками крови, а шейка закрыта). В зависимости от объема скопившейся крови данная ситуация разрешается с помощью медикаментов или повторного расширения шеечного канала и вакуум-аспирации сгустков. Профилактировать данное осложнение можно приемом спазмолитиков в вечер после проведения аборта (например, 1-2-3 таблетки дротаверина или но-шпа).\n• Длительное кровотечение, а также боли в нижней части живота могут свидетельствовать о том, что процедура была выполнена не полностью и в полости матки остались зародышевые элементы, что может инициировать серьёзные воспалительные процессы. В случае неполного аборта возникает необходимость дополнительного хирургического вмешательства (выскабливания остатков плодного яйца из полости матки).\n• Плацентарный полип – на контрольном УЗИ через 2-4 месяца после аборта появляется полиповидный вырост слизистой полости матки. Клинически это может проявляться болезненеными и нерегулярными менструациями после прерывания беременности. Плацентарный полип вырастает из остатков ворсин тканей плодного яйца. Удалять плацентарный полип также приходится под наркозом, с расширением шейки матки, обычно с помощью кюретки и гистероскопа (инструмента с видеокамерой для осмотра матки изнутри).\n• Постабортная депрессия.\nВоспаление после аборта\nЕще одним поздним осложнением аборта может быть присоединение воспалительного процесса. При аборте это обычно происходит, если у пациентки снижен иммунитет и присутствует хроническая инфекция в нижних половых путях. Даже после санации воспалительного типа мазка перед абортом в половых путях могут остаться агрессивные микроорганизмы, которые при введении инструментов в матку попадают в нее из влагалища. Микротравмы стенок и шейки матки способствуют развитию воспаления.\nВ случае острого воспаления у пациентки появятся:\n• боли внизу живота,\n• лихорадка,\n• гнойные или ослизненные выделения из половых путей.\nЭто клиника эндометрита (воспаления слизистой матки). Из матки воспалительный процесс восходящим путем может распространиться на маточные трубы и в малый таз.\nПри воспалении и появлении гноя в маточных трубах развивается сальпингит.\nПри втягивании в процесс яичника возникает сальпингоофорит и формируются спайки между яичником, трубами и маткой.\nПациенток после лечения еще длительно могут беспокоить «бели» из половых путей.\nПри излитии гноя из маточных труб в полость малого таза развивается перитонит, воспаление и спаечный процесс распространяется на соседние органы (петли кишечника, мочевой пузырь). Потребуется длительная противовоспалительная и антибактериальная терапия, при наличии гноя в маточных трубах и малом тазу – оперативное лечение.\nОтдаленные последствия\nМогут наблюдаться через годы после операции:\n• После аборта всегда есть риск возникновения гормонального сдвига, в связи с чем может нарушиться менструальный цикл и нормальное созревание фолликулов в яичниках. Это, в свою очередь, увеличивает риск появления эндокринного фактора бесплодия.\n• Вышеописанные воспалительные процессы половых органов могут привести к развитию спаечного процесса и непроходимости маточных труб (в дальнейшем - трубный фактор бесплодия). Воспаление слизистой матки также является частой причиной нарушений менструального цикла.\n• Перенесенные воспалительные процессы и наличие спаек в малом тазу могут быть причиной синдрома хронической тазовой боли у женщин, который очень трудно поддается коррекции.\n• Травмированная при аборте шейка матки может недостаточно выполнять запирающую функцию при беременности. Из-за недостаточности шейки матки могут происходить потери беременности в различных сроках или создаваться показания для наложения хирургического шва на шейку для сохранения беременности.\nВлияние на последующие беременности\nЕсли аборт протекал с осложнениями, то это может «аукнуться» женщине неблагоприятным течением последующей желанной беременности.\n• Во-первых, у пациенток с воспалительными заболеваниями женских половых органов и спаечным процессом в малом тазу после осложненного аборта может наступить внематочная беременность. Это происходит потому, что маточные трубы в результате воспаления становятся извитыми, отечными, с перегибами из-за прилежащих спаек, движение яйцеклетки по ним затруднено.\n• При попадании оплодотворенной яйцеклетки в полость матки с хроническим воспалением слизистой после аборта, она может неполноценно прикрепиться к стенке матки. Это приводит к замершей беременности или развитию кровотечения и отторжению беременности. Если же беременность прижилась и развивается дальше, то плацента, прикрепившаяся к неполноценной стенке матки, может быть тощей, не обеспечивать питательной функции, на УЗИ может быть описано маловодие или многоводие, отставание ребенка в росте.\n• Если у женщины аборт осложнился перфорацией стенки матки, то теперь у нее имеет место рубец на матке. При беременности и родах некоторые рубцы на матке бывают несостоятельными (при этом редко, но случается разрыв матки по несостоятельному рубцу в поздних сроках беременности и в родах).\n• Если при аборте расширение шейки матки проводилось травматично, то при следующей желанной беременности может проявиться недостаточность шейки матки (истмико-цервикальная недостаточность). Это клинически проявляется признаками угрозы прерывания, преждевременным раскрытием шейки, может закончиться выкидышем. Иногда при беременности недостаточность шейки матки приходится корригировать наложением шва или постановкой разгрузочного пессария.\n• Если пациентка с резус-отрицательной группой крови сделает аборт от резус-положительного партнера, то в ее организме при следующей беременности может возникнуть резус-несовместимость с будущим ребенком. Для профилактики этого осложнения резус-отрицательным женщинам при проведении аборта рекомендуется всегда вводить дозу антирезусного иммуноглобулина.\nВосстановление и реабилитация после аборта\nНа продолжительность периода восстановления влияют возраст женщины, состояние ее здоровья, количество перенесенных ранее абортов и наличие детей. Легче аборт переносят здоровые молодые женщины, уже имеющие детей.\nМедицинская реабилитация подразумевает предоставить отдых женской половой системе, перенесшей гормональный взрыв из-за искусственного прерывания беременности. Из-за перепада гормонов менструальный цикл может не восстановиться, а в яичниках и молочных железах часто возникают кисты. В течение полугода как минимум не должно наступать следующей (желанной или не желанной) беременности, не должно быть резких колебаний гормонального фона женщины. Женщина должна понимать, что следующий аборт усугубит гормональный дисбаланс в организме. Нужно обеспечить себя надежным средством контрацепции.\nЕсли аборт осложнился воспалительным процессом, то период реабилитации и восстановления должен включать дополнительно мероприятия по восстановлению нормальной микрофлоры во влагалище, физиотерапевтические методы профилактики и рассасывания спаек внутренних половых органов. Женщине назначают электрофорез на низ живота с противовоспалительными препаратами, санаторно-курортное лечение, гирудотерапию, лазерное облучение и УФО крови, ферментные препараты для уменьшения выраженности спаечного процесса.\nЕще одна важная составляющая восстановления – психологическая реабилитация. У женщин могут развиваться депрессии, чувство вины, нарушаться сексуальная функция. Поэтому во многих случаях рекомендуется помощь психологов.\n\n\nОб осложнениях искусственного аборта'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': 'При искусственном прерывании беременности у 10-20 % женщин возникают гинекологические заболевания,\nчасто обостряются хронические заболевания женских половых органов. Есть опасность инфицирования при аборте, когда при распространении инфекции могут развиться метроэндометрит, параметрит, метрит, тазовый перитонит.\nДовольно часто после аборта наблюдаются остатки плодного яйца. При задержке частей плодного яйца рекомендовано повторное выскабливание матки.\nТакже частыми осложнениями являются – истмико-цервикальная недостаточность, нарушение менструального цикла.\nСамым тяжелым осложнением является перфорация матки, но встречается очень редко.\nОтдаленными последствиями искусственного аборта могут быть вторичное бесплодие, угрожающий выкидыш, самопроизвольные аборты, трубная беременность, привычное невынашивание.\nПрерывание беременности может вызывать нарушения нервной системы. В первые месяцы после аборта повышается возбудимость. Кроме того, аборт являясь психической травмой, может вызвать развитие психастении, навязчивых состояний.\nВсе вышеперечисленные осложнения чаще встречаются у женщин с инфантилизмом и у девочек-подростков, чем у здоровых рожавших женщин. У них восстановление менструальной функции может затягиваться до года и более, т.к. у здоровых рожавших женщин она восстанавливается на 3-4 месяц. Также чаще у них встречается невынашивание беременности и трубное бесплодие.\nПоэтому в случае наступления нежелательной беременности прерывание должно производиться в оптимальные сроки – в течение первых 8 недель беременности, обязательно в медицинском учреждении высококвалифицированным врачом при адекватном обезболивании и с обязательным назначением послеабортной реабилитации.\n'
        },
        {
            'attributes': {
                'bold': true
            },
            'insert': 'Реабилитация'
        },
        {
            'insert': '\nРеабилитация после аборта предполагает назначение комбинированных контрацептивов, антибиотиков коротким курсом, антистрессовых витаминов.\nПрименение оральной контрацепции является профилактикой эндокринных нарушений, т.к. нормализует регуляцию гормонов, нарушенную стрессом, коим для организма является аборт. Помимо этого назначение контрацептивов уменьшает риск развития воспалительных заболеваний:\nУменьшается количество теряемой менструальной крови, которая является прекрасной средой для возбудителей воспалительных заболеваний половых органов.'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'Происходят изменения, препятствующие проникновению сперматозоидов, а с ними и возбудителей инфекционных заболеваний в полость матки.'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'Происходит меньшее расширение цервикального канала, что уменьшает возможность проникновения инфекции в матку.'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'Уменьшается интенсивность маточных сокращений, что приводит к уменьшению риска распространения воспалительного процесса из маточной полости в фаллопиевы трубы.'
        },
        {
            'attributes': {
                'list': 'ordered'
            },
            'insert': '\n'
        },
        {
            'insert': 'Применение оральных контрацептивов снижает риск развития острых бактериальных заболеваний органов малого таза у женщин на 50%; возникновение внематочной беременности на 90%.\nПри необходимости предохранения после аборта первую таблетку контрацептива рекомендуется применять не позднее первого дня после операции, ее контрацептивная защита в данном случае наступает сразу же. Если первая таблетка принята не позднее 5-го дня от момента операции, контрацептивная защита наступает не сразу и женщине необходимо 7 дней предохраняться от беременности дополнительными методами.\nОральные контрацептивы следует применять не менее трех менструальных циклов после аборта, и более.\nС целью профилактики инфекционных осложнений назначаются антибиотики ширококого спектра действия коротким курсом (не более 7 дней).\nДля адаптации организма рекомендуются антистрессовые витамины (компливит и др.) в течение 1-3 месяца.\nТакая реабилитация предупреждает осложнения и последствия аборта и обеспечивает практически 100% контрацепцию.\n\n\nО социальных гарантиях и пособиях федерального и регионального уровня для беременных женщин и семей с детьми'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'underline': true,
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/'
            },
            'insert': 'Социальный фонд России'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children'
            },
            'insert': 'https://sfr.gov.ru/grazhdanam/families_with_children'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/edinoe_posobie'
            },
            'insert': 'Ежемесячное пособие в связи с рождением и воспитанием ребенка (Единое пособие)'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children/pregnant'
            },
            'insert': 'Пособие по беременности и родам'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children/birth'
            },
            'insert': 'Единовременное пособие при рождении ребенка'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children/care'
            },
            'insert': 'Ежемесячное пособие по уходу за ребенком (до 1,5 лет)'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children/adoption_of_a_child/'
            },
            'insert': 'Единовременное пособие при усыновлении ребенка'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children/firstchild/'
            },
            'insert': 'Ежемесячная выплата в связи с рождением (усыновлением) первого ребенка'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children/new_subjects'
            },
            'insert': 'Предоставление мер социальной поддержки семьям с детьми, проживающим (проживавшим) в новых субъектах Российской Федерации'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children'
            },
            'insert': 'Компенсационная / ежемесячная выплата неработающему родителю ребенка-инвалида или инвалида с детства первой группы, а также другим лицам, осуществляющим уход за такими инвалидами'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/invalidam/soc_vip_inv/viplati_po_uhody/get_viplati_po_uhody/comp_vyp/'
            },
            'insert': 'Компенсационная выплата'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/invalidam/soc_vip_inv/viplati_po_uhody/get_viplati_po_uhody/ev_month/'
            },
            'insert': 'Ежемесячная выплата'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children'
            },
            'insert': 'Материнский (семейный капитал) и способы распоряжения его средствами'
        },
        {
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/msk/get_paid/'
            },
            'insert': 'ежемесячная выплата из средств материнского капитала'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/msk/msk_housing/'
            },
            'insert': 'улучшение жилищных условий'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/msk/msk_obrazovanie/'
            },
            'insert': 'образование детей'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/msk/msk_na_pension/'
            },
            'insert': 'накопительная пенсия мамы'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/msk/msk_adaptation/'
            },
            'insert': 'социальная адаптация и интеграция в общество детей-инвалидов'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/families_with_children'
            },
            'insert': 'Меры поддержки семьям с детьми'
        },
        {
            'insert': '\nСемьям военных и сотрудников силовых ведомств\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/social_support/mery_podderzhki/families_with_children/conscript'
            },
            'insert': 'Единовременное пособие беременной жене военнослужащего, проходящего военную службу по призыву'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/social_support/mery_podderzhki/families_with_children/child_of_military_service'
            },
            'insert': 'Ежемесячное пособие на ребенка военнослужащего по призыву'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/social_support/mery_podderzhki/Military_families/summer_camp'
            },
            'insert': 'Ежегодная выплата на летний оздоровительный отдых ребенка'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/social_support/mery_podderzhki/Military_families/allowance_for_children/'
            },
            'insert': 'Ежемесячное пособие детям военнослужащих'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'insert': 'Семьям, подвергшимся воздействию радиации\n \n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/social_support/mery_podderzhki/radiation/ch_for_child'
            },
            'insert': 'Ежемесячная выплата на детей до 3 лет'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/social_support/mery_podderzhki/radiation/child_food'
            },
            'insert': 'Ежемесячная компенсация на питание детей'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#337ab7',
                'link': 'https://sfr.gov.ru/grazhdanam/social_support/mery_podderzhki/radiation/milk'
            },
            'insert': 'Ежемесячная компенсация на питание с молочной кухни для детей до 3 лет'
        },
        {
            'attributes': {
                'list': 'bullet'
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': '\n\n\n'
        },
        {
            'attributes': {
                'color': '#e60000'
            },
            'insert': 'Телефон горячей линии «Стоп-аборт» '
        },
        {
            'attributes': {
                'header': 2
            },
            'insert': '\n'
        },
        {
            'insert': '\nТелефон горячей линии «Стоп-аборт» Бесплатный социальный телефон общероссийской круглосуточной кризисной линии помощи 8-800-100-48-77 позвонив по которому, можно получить профессиональную психологическую и юридическую помощь, консультацию врача, а также предоставляется информация о региональных приютах, организациях и центрах защиты материнства (более 700 пунктов помощи по РФ), оказывающих продовольственную и гуманитарную помощь кризисным беременным женщинам и семьям находящимся в тяжелой жизненной ситуации. '
        },
        {
            'attributes': {
                'blockquote': true
            },
            'insert': '\n'
        },
        {
            'attributes': {
                'color': '#e60000'
            },
            'insert': '8-800-2000-492'
        },
        {
            'insert': '-телефон «горячей линии»поддержки беременных женщин.'
        },
        {
            'attributes': {
                'blockquote': true
            },
            'insert': '\n'
        }
    ]
};
        },
        prices() {
            return this.$store.state.clinic.organization.form.front.prices ?
            this.$store.state.clinic.organization.form.front.prices : [{insert: 'Не заполнено'}];
        },
        isOrgAdmin() {
            const role = this.$store.state.clinic.roles.filter(obj => obj === 'orgadmin')[0];
            return role ? true : false;
        },
    },
    created() {
        window.addEventListener('resize', this.resizeHandler);
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    mounted() {
        this.quill = new Quill('#viewer', {
         /*   theme: 'bubble',  растягивает по высоте на мозилле*/
            readOnly:true
        });
        console.log(this.$store.state.clinic);
        if (this.$route.query.page) {
            if (this.$route.query.page === 'common_info') {
                this.chooseMenu(this.commonInfo, { title: 'Общая информация', value: 'common_info'});
            } else if (this.$route.query.page === 'prices') {
                this.chooseMenu(this.prices, { title:'Цены', value: 'prices'});
            } else {
                const srv = this.services.filter(obj => obj.text === this.$route.query.page)[0];
                if (srv) {
                    this.currentService(srv);
                }
            }
        } else {
            this.quill.setContents(this.commonInfo);
        }
        this.desktop = window.innerWidth > 1100;
    },
    methods: {
        closeEdit() {
            this.open_edit = false;
        },
        openEdit() {
            this.open_edit = true;
            const toolbarOptions = [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote'],

                    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'font': [] }],
                    [{ 'align': [] }],
                    ['image'], ['link']

                ];
            setTimeout(() => { this.edit_quill = new Quill('#editor', {
                theme: 'snow',
                readOnly:false,
                modules: {
                        toolbar: toolbarOptions
                    }
            });
            this.edit_quill.setContents(this.quill.getContents());
            }, 100);
            
        },
        edit_content() {
            this.quill.setContents(this.edit_quill.getContents());
            const front = this.$store.state.clinic.organization.form.front;
            let backup;
            if (this.currentMenu.value === 'services') {
                backup = Object.assign([], front[this.currentMenu.value].services);
                front[this.currentMenu.value][front.services.findIndex(obj => obj.text === this.currentSrv.text)].content = Object.assign({}, this.edit_quill.getContents());
            } else {
                backup = Object.assign({}, front[this.currentMenu.value]);
                front[this.currentMenu.value] = Object.assign({}, this.edit_quill.getContents());
            }
            organizationApi.update({front: front}).then(res => {
                this.open_edit = false;
            }).catch(error => {
                console.log(error);
                front[this.currentMenu.value] = backup.length > 0 ? Object.assign([], backup) : Object.assign({}, backup);
            });
        },
        currentService(srv) {
            if (this.services) {
                this.currentSrv = srv;
                this.currentMenu = { value: 'services', title: `Услуги: ${srv.text}`};
                const curSrv = srv.content;
                if (curSrv) {
                    this.quill.setContents(curSrv);
                } else {
                    this.quill.setText('Не заполнено');
                }
            }
        },
        chooseMenu(content, menu) {
            this.$route.query.page = menu.value;
            console.log(this.$route);
            this.currentMenu = menu;
            this.quill.setContents(content);
        },
        resizeHandler({ target }) {
            const isDesktop = target.innerWidth > 1100;
            let bool;
            if (isDesktop) {
                if (!this.desktop) {
                bool = true;
                }
            } else if (this.desktop) {
                bool = false;
            }
            this.desktop = isDesktop;
        },
    }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-container {
    width:90%;
}
    .rounded {
counter-reset: li; 
list-style: none; 
font: 16px "Trebuchet MS", "Lucida Sans";
padding: 0;
text-shadow: 0 1px 0 rgba(255,255,255,.5);
cursor: pointer;
}
.rounded a {
position: relative;
display: block;
padding: .4em .4em .4em 2em;
margin: .5em 0;
background: #DAD2CA;
color: #444;
text-decoration: none;
border-radius: .3em;
transition: .3s ease-out;
//height:30px;
}
.rounded a:hover {background: #E9E4E0;}
.rounded a:hover:before {transform: rotate(360deg);}
.rounded a:before {
content: counter(li);
counter-increment: li;
position: absolute;
left: -1.3em;
top: 50%;
margin-top: -1.3em;
background: #8FD4C1;
height: 30px;
width: 30px;
line-height: 2em;
border: .3em solid white;
text-align: center;
font-weight: bold;
border-radius: 2em;
transition: all .3s ease-out;
}
li {
    margin:1rem;
}

.info {
    border-radius: .3em;
    background: #DAD2CA;
    color: #444;
    padding: .4em .4em .4em 2em;
    margin: .4em;
    font: 18px "Trebuchet MS", "Lucida Sans";
    text-shadow: 0 1px 0 rgba(255,255,255,.5);
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.info:hover {
    background: #E9E4E0;
}
.uslugi {
    padding:1rem 4rem 1rem 4rem;
}
.patients {
    display:flex;
    flex-direction:row;
    width:100%;
}
@media screen and (max-width: 1024px) {
.uslugi {
    padding:0;
}
.patients {
    display:flex;
    flex-direction:column;
}
}
</style>
